<template>
  <div class="chat-wrapper">
    <!-- Container Principal -->
    <div class="chat-main-container">
      <!-- Conteúdo do Chat -->
      <div v-if="isConnected" class="chat-content">
        <!-- Sidebar de Conversas -->
        <div
          class="conversations-sidebar"
          v-show="!isMobile || !selectedConversation"
        >
          <!-- Sidebar Header -->
          <div class="sidebar-header">
            <div class="header-top">
              <span class="sidebar-title">Conversas</span>
            </div>
            <div class="sidebar-actions">
              <!-- <v-btn
                  icon
                  small
                  class="btn"
                  @click="loadConversations"
                  title="Atualizar"
                >
                  <v-icon size="18">mdi-refresh</v-icon>
                </v-btn> -->

              <v-select
                v-model="userStatus"
                :items="statusOptions"
                dense
                hide-details
                solo
                flat
                class="status-select"
                @change="updateUserStatus"
              >
                <template v-slot:selection="{ item }">
                  <div class="status-chip">
                    <v-icon size="16" :color="getStatusIcon(item.value).color">
                      {{ getStatusIcon(item.value).icon }}</v-icon
                    >
                    <span class="status-text">{{ truncate(item.text, 10) }}</span>
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  <div class="status-option">
                    <v-icon size="16" :color="getStatusIcon(item.value).color">
                      {{ getStatusIcon(item.value).icon }}</v-icon
                    >
                    <span>{{ item.text }}</span>
                  </div>
                </template>
              </v-select>
              <div class="sidebar-action-buttons">
                <v-btn
                  icon
                  small
                  class="btn"
                  title="Configurações do bate-papo"
                  @click="openChatSettingsDialog"
                >
                  <v-icon size="18">mdi-cog-outline</v-icon>
                </v-btn>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      class="primary-action"
                      v-bind="attrs"
                      v-on="on"
                      title="Nova conversa"
                    >
                      <v-icon size="18">mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item link @click="openStartConversationDialog">
                      <v-list-item-icon class="mr-3">
                        <v-icon small color="#4caf50">mdi-account-plus</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Iniciar nova conversa</v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="openNewGroupDialog">
                      <v-list-item-icon class="mr-3">
                        <v-icon small color="#4caf50">mdi-account-group</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Criar grupo</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>

          <!-- Search -->
          <div class="sidebar-search">
            <v-text-field
              v-model="searchQuery"
              placeholder="Buscar conversas..."
              prepend-inner-icon="mdi-magnify"
              dense
              hide-details
              solo
              flat
              class="search-input"
            ></v-text-field>
          </div>

          <!-- Lista de Conversas -->
          <div class="conversations-list">
            <template v-if="filteredConversations.length > 0">
              <v-expansion-panels multiple flat v-model="panel">
                <!-- Seção de Conversas Favoritas -->
                <v-expansion-panel
                  v-if="hasFavoritos"
                  class="conversation-expansion"
                >
                  <v-expansion-panel-header
                    class="section-header"
                    expand-icon="mdi-chevron-down"
                  >
                    <span class="section-title">Favoritos</span>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <div class="conversation-section">
                      <div
                        v-for="(
                          conversation, index
                        ) in groupedConversations.favoritos"
                        :key="'fav-' + conversation.id"
                        class="conversation-item"
                        :class="{
                          active:
                            selectedConversation &&
                            selectedConversation.id === conversation.id,
                        }"
                        @click="selectConversation(conversation)"
                      >
                        <div class="conversation-avatar">
                          <div
                            class="avatar-circle"
                            :class="
                              conversation.tipo === 'SISTEMA'
                                ? 'avatar-system'
                                : getAvatarColor(conversation.id)
                            "
                          >
                            <v-icon
                              v-if="conversation.tipo === 'SISTEMA'"
                              size="25"
                              color="white"
                            >
                              mdi-shield-check
                            </v-icon>
                            <template v-else>
                              {{ getInitials(conversation?.nomeChat) }}
                            </template>
                          </div>
                          <span
                            v-if="conversation.tipo === 'GRUPO'"
                            class="group-indicator"
                          >
                            <v-icon size="10" color="white"
                              >mdi-account-group</v-icon
                            >
                          </span>
                          <span
                            v-if="conversation.tipo === 'SELF_CHAT'"
                            class="self-chat-indicator"
                          >
                            <v-icon size="10" color="white">mdi-bookmark</v-icon>
                          </span>
                          <span
                            v-if="conversation.tipo === 'PRIVADA'"
                            class="status-indicator"
                            :class="`status-${conversation.participantes[0].status.toLowerCase()}`"
                          >
                            <v-icon
                              size="16"
                              :color="
                                getStatusIcon(
                                  conversation.participantes[0].status,
                                ).color
                              "
                            >
                              {{
                                getStatusIcon(
                                  conversation.participantes[0].status,
                                ).icon
                              }}
                            </v-icon>
                          </span>
                        </div>

                        <div class="conversation-info">
                          <div class="conversation-header-row">
                            <div class="conversation-info">
                              <div class="d-flex align-center">
                                <span class="conversation-name">{{
                                  conversation?.nomeChat
                                }}</span>
                              </div>
                              <div class="conversation-cargo">
                                {{
                                  truncate(
                                    conversation?.cargoColaborador,
                                    21,
                                  ) || ""
                                }}
                              </div>
                            </div>
                            <span class="conversation-time">
                              {{
                                conversation.ultimaMensagem
                                  ? formatMessageDateTime(
                                      conversation.ultimaMensagem.dataEnvio,
                                    )
                                  : ""
                              }}
                            </span>
                          </div>
                          <div class="conversation-preview">
                            <div class="preview-content">
                              <v-icon
                                v-if="
                                  conversation.ultimaMensagem &&
                                  conversation.ultimaMensagem.idRemetente ===
                                    currentUser.id
                                "
                                size="14"
                                class="mr-1"
                                :color="
                                  conversation.ultimaMensagem.lida
                                    ? 'blue'
                                    : 'grey'
                                "
                              >
                                {{
                                  conversation.ultimaMensagem.lida
                                    ? "mdi-check-all"
                                    : "mdi-check"
                                }}
                              </v-icon>
                              <div class="preview-text-container">
                                <span
                                  v-if="
                                    conversation.tipo === 'GRUPO' &&
                                    conversation.ultimaMensagem &&
                                    conversation.ultimaMensagem.idRemetente !==
                                      currentUser.id
                                  "
                                  class="sender-name"
                                >
                                  {{
                                    getNomeRemetente(
                                      conversation.ultimaMensagem,
                                    )
                                  }}
                                </span>
                                <span
                                  class="preview-text"
                                  v-html="
                                    conversation.ultimaMensagem
                                      ? formatarMensagemPreview(
                                          conversation.ultimaMensagem,
                                        )
                                      : 'Sem mensagens'
                                  "
                                ></span>
                              </div>
                            </div>
                            <v-badge
                              v-if="conversation.mensagensNaoLidas > 0"
                              :content="conversation.mensagensNaoLidas"
                              color="#4caf50"
                              class="mr-4"
                            ></v-badge>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- Seção de Chats (com mensagens) -->
                <v-expansion-panel
                  v-if="hasChats"
                  class="conversation-expansion"
                >
                  <v-expansion-panel-header
                    class="section-header"
                    expand-icon="mdi-chevron-down"
                  >
                    <span class="section-title">CHATS</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="conversation-section">
                      <div
                        v-for="(
                          conversation, index
                        ) in groupedConversations.chats"
                        :key="'chat-' + conversation.id"
                        class="conversation-item"
                        :class="{
                          active:
                            selectedConversation &&
                            selectedConversation.id === conversation.id,
                        }"
                        @click="selectConversation(conversation)"
                      >
                        <!-- Conteúdo do item de conversa (mesmo que o original) -->
                        <div class="conversation-avatar">
                          <div
                            class="avatar-circle"
                            :class="
                              conversation.tipo === 'SISTEMA'
                                ? 'avatar-system'
                                : getAvatarColor(conversation.id)
                            "
                          >
                            <v-icon
                              v-if="conversation.tipo === 'SISTEMA'"
                              size="25"
                              color="white"
                            >
                              mdi-shield-check
                            </v-icon>
                            <template v-else>
                              {{ getInitials(conversation?.nomeChat) }}
                            </template>
                          </div>
                          <span
                            v-if="conversation.tipo === 'GRUPO'"
                            class="group-indicator"
                          >
                            <v-icon size="10" color="white"
                              >mdi-account-group</v-icon
                            >
                          </span>
                          <span
                            v-if="conversation.tipo === 'SELF_CHAT'"
                            class="self-chat-indicator"
                          >
                            <v-icon size="10" color="white">mdi-bookmark</v-icon>
                          </span>
                          <span
                            v-if="conversation.tipo === 'PRIVADA'"
                            class="status-indicator"
                            :class="`status-${conversation.participantes[0].status.toLowerCase()}`"
                          >
                            <v-icon
                              size="16"
                              :color="
                                getStatusIcon(
                                  conversation.participantes[0].status,
                                ).color
                              "
                            >
                              {{
                                getStatusIcon(
                                  conversation.participantes[0].status,
                                ).icon
                              }}
                            </v-icon>
                          </span>
                        </div>

                        <div class="conversation-info">
                          <div class="conversation-header-row">
                            <div class="conversation-info">
                              <div class="d-flex align-center">
                                <span class="conversation-name">{{
                                  conversation?.nomeChat
                                }}</span>
                              </div>
                              <div class="conversation-cargo">
                                {{
                                  truncate(
                                    conversation?.cargoColaborador,
                                    21,
                                  ) || ""
                                }}
                              </div>
                            </div>
                            <span class="conversation-time">
                              {{
                                conversation.ultimaMensagem
                                  ? formatMessageDateTime(
                                      conversation.ultimaMensagem.dataEnvio,
                                    )
                                  : ""
                              }}
                            </span>
                          </div>
                          <div class="conversation-preview">
                            <div class="preview-content">
                              <v-icon
                                v-if="
                                  conversation.ultimaMensagem &&
                                  conversation.ultimaMensagem.idRemetente ===
                                    currentUser.id
                                "
                                size="14"
                                class="mr-1"
                                :color="
                                  conversation.ultimaMensagem.lida
                                    ? 'blue'
                                    : 'grey'
                                "
                              >
                                {{
                                  conversation.ultimaMensagem.lida
                                    ? "mdi-check-all"
                                    : "mdi-check"
                                }}
                              </v-icon>
                              <div class="preview-text-container">
                                <span
                                  v-if="
                                    conversation.tipo === 'GRUPO' &&
                                    conversation.ultimaMensagem &&
                                    conversation.ultimaMensagem.idRemetente !==
                                      currentUser.id
                                  "
                                  class="sender-name"
                                >
                                  {{
                                    getNomeRemetente(
                                      conversation.ultimaMensagem,
                                    )
                                  }}
                                </span>
                                <span
                                  class="preview-text"
                                  v-html="
                                    conversation.ultimaMensagem
                                      ? formatarMensagemPreview(
                                          conversation.ultimaMensagem,
                                        )
                                      : 'Sem mensagens'
                                  "
                                ></span>
                              </div>
                            </div>
                            <v-badge
                              v-if="conversation.mensagensNaoLidas > 0"
                              :content="conversation.mensagensNaoLidas"
                              color="#4caf50"
                              class="mr-4"
                            ></v-badge>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <!-- Seção de Iniciar Conversa (sem mensagens) -->
                <v-expansion-panel
                  v-if="hasSemMensagens"
                  class="conversation-expansion"
                >
                  <v-expansion-panel-header
                    class="section-header"
                    expand-icon="mdi-chevron-down"
                  >
                    <span class="section-title">INICIAR CONVERSA</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="conversation-section">
                      <div
                        v-for="(
                          conversation, index
                        ) in groupedConversations.semMensagens"
                        :key="'new-' + conversation.id"
                        class="conversation-item"
                        :class="{
                          active:
                            selectedConversation &&
                            selectedConversation.id === conversation.id,
                        }"
                        @click="selectConversation(conversation)"
                      >
                        <!-- Conteúdo do item de conversa (mesmo que o original) -->
                        <div class="conversation-avatar">
                          <div
                            class="avatar-circle"
                            :class="
                              conversation.tipo === 'SISTEMA'
                                ? 'avatar-system'
                                : getAvatarColor(conversation.id)
                            "
                          >
                            <v-icon
                              v-if="conversation.tipo === 'SISTEMA'"
                              size="25"
                              color="white"
                            >
                              mdi-shield-check
                            </v-icon>
                            <template v-else>
                              {{ getInitials(conversation?.nomeChat) }}
                            </template>
                          </div>
                          <span
                            v-if="conversation.tipo === 'GRUPO'"
                            class="group-indicator"
                          >
                            <v-icon size="10" color="white"
                              >mdi-account-group</v-icon
                            >
                          </span>
                          <span
                            v-if="conversation.tipo === 'SELF_CHAT'"
                            class="self-chat-indicator"
                          >
                            <v-icon size="10" color="white">mdi-bookmark</v-icon>
                          </span>
                          <span
                            v-if="conversation.tipo === 'PRIVADA'"
                            class="status-indicator"
                            :class="`status-${conversation.participantes[0].status.toLowerCase()}`"
                          >
                            <v-icon
                              size="16"
                              :color="
                                getStatusIcon(
                                  conversation.participantes[0].status,
                                ).color
                              "
                            >
                              {{
                                getStatusIcon(
                                  conversation.participantes[0].status,
                                ).icon
                              }}
                            </v-icon>
                          </span>
                        </div>

                        <div class="conversation-info">
                          <div class="conversation-header-row">
                            <div class="conversation-info">
                              <div class="d-flex align-center">
                                <span class="conversation-name">{{
                                  conversation?.nomeChat
                                }}</span>
                              </div>
                              <div class="conversation-cargo">
                                {{
                                  truncate(
                                    conversation?.cargoColaborador,
                                    21,
                                  ) || ""
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="conversation-preview">
                            <div class="preview-content">
                              <div class="preview-text-container">
                                <span class="preview-text"
                                  >Iniciar uma nova conversa</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template>

            <!-- Estado Vazio -->
            <div v-else class="empty-conversations">
              <v-icon size="48" color="#cbd5e1">mdi-chat-outline</v-icon>
              <span>Nenhuma conversa encontrada</span>
            </div>
          </div>
        </div>

        <!-- Área Principal do Chat -->
        <div class="chat-area" v-show="!isMobile || selectedConversation">
          <template v-if="selectedConversation">
            <!-- Chat Header -->
            <div class="chat-header">
              <div class="chat-header-left">
                <!-- Botão voltar (somente mobile) -->
                <v-btn
                  icon
                  small
                  class="btn mr-2"
                  v-if="isMobile"
                  @click="voltarParaLista"
                  title="Voltar para lista de conversas"
                >
                  <v-icon size="20">mdi-arrow-left</v-icon>
                </v-btn>

                <div
                  class="chat-avatar"
                  :class="
                    selectedConversation.tipo === 'SISTEMA'
                      ? 'avatar-system'
                      : getAvatarColor(selectedConversation?.id)
                  "
                >
                  <v-icon
                    v-if="selectedConversation.tipo === 'SISTEMA'"
                    size="24"
                    color="white"
                  >
                    mdi-shield-check
                  </v-icon>
                  <template v-else>
                    {{ getInitials(selectedConversation?.nomeChat) }}
                  </template>
                </div>
                <div
                  class="chat-info"
                  :class="{ 'cursor-pointer': selectedConversation.tipo === 'GRUPO' }"
                  @click="selectedConversation.tipo === 'GRUPO' ? abrirDialogGrupo() : null"
                >
                  <div class="d-flex align-center">
                    <span class="chat-name">{{
                      selectedConversation?.nomeChat
                    }}</span>
                    <v-icon
                      v-if="selectedConversation.favorito"
                      size="16"
                      color="amber"
                      class="ml-1"
                    >
                      mdi-star
                    </v-icon>
                  </div>
                  <span
                    class="chat-status"
                    v-if="selectedConversation.tipo === 'GRUPO'"
                  >
                    <span class="online-dot"></span>
                    {{ participantesOnline }} online
                  </span>

                  <span
                    class="chat-status"
                    v-else-if="selectedConversation.tipo === 'SELF_CHAT'"
                  >
                    <v-icon size="16" class="mr-1" color="#4caf50">
                      mdi-bookmark
                    </v-icon>
                    Mensagens para mim
                  </span>

                  <span
                    class="chat-status"
                    v-else-if="isConversaSistema"
                  >
                    <v-icon size="16" class="mr-1" color="#64748b">
                      mdi-shield-message-outline
                    </v-icon>
                    Somente o sistema pode enviar mensagens
                  </span>

                  <span class="chat-status" v-else>
                    <v-icon
                      size="16"
                      class="mr-1"
                      :color="
                        getStatusIcon(
                          selectedConversation.participantes[0].status,
                        ).color
                      "
                    >
                      {{
                        getStatusIcon(
                          selectedConversation.participantes[0].status,
                        ).icon
                      }}
                    </v-icon>

                    {{
                      formatarStatus(
                        selectedConversation.participantes[0].status,
                      )
                    }}
                  </span>
                </div>
              </div>
              <div v-if="menuItems.length" class="chat-header-actions">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small class="btn" v-bind="attrs" v-on="on">
                      <v-icon size="20">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <div v-for="(item, index) in menuItems">
                      <v-list-item :key="item.key" @click="item.action">
                        <v-list-item-icon class="mr-2">
                          <v-icon small :color="item.color">
                            {{ item.icon }}
                          </v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.title }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-divider
                        v-if="index < menuItems.length - 1"
                        :key="`${item.key}-divider`"
                      />
                    </div>
                  </v-list>
                </v-menu>
              </div>
            </div>

            <!-- Mensagens -->
            <div class="messages-area">
            <div
              v-if="loadingMessages"
              class="messages-container messages-loading"
            >
              <v-progress-circular
                indeterminate
                color="#4caf50"
                size="42"
                width="4"
              ></v-progress-circular>
              <span>Carregando mensagens...</span>
            </div>

            <div
              v-else-if="messages.length > 0"
              ref="messagesContainer"
              class="messages-container"
              @scroll="handleMessagesScroll"
            >
              <div class="messages-wrapper">
                <template v-for="message in messages">
                  <!-- Mensagem do Sistema -->
                  <div
                    v-if="message.tipo === 'SISTEMA'"
                    :key="'system-' + message.id"
                    class="message-system-wrapper"
                  >
                    <div class="message-system">
                      <div
                        class="message-system-content"
                        v-html="formatarMensagem(message.conteudo)"
                      ></div>
                    </div>
                  </div>

                  <!-- Mensagem de Data (Separador) -->
                  <div
                    v-else-if="message.tipo === 'DATA'"
                    :key="'date-' + message.id"
                    class="message-date-wrapper"
                  >
                    <div class="message-date">
                      <div class="message-date-content">
                        {{ message.conteudo }}
                      </div>
                    </div>
                  </div>

                  <!-- Mensagem Normal -->
                  <div
                    v-else
                    :key="'normal-' + message.id"
                    class="message-row"
                    :data-message-id="message.id"
                    :class="{
                      sent: message.idRemetente === currentUser.id,
                      received: message.idRemetente !== currentUser.id,
                    }"
                    :style="estiloLinhaSelecao(message)"
                    @click="modoSelecao && alternarSelecao(message)"
                  >
                    <span
                      v-if="modoSelecao && podeSelecionarMensagem(message)"
                      :style="estiloCheckboxSelecao"
                      role="checkbox"
                      :aria-checked="estaSelecionada(message) ? 'true' : 'false'"
                    >
                      <v-icon :color="estaSelecionada(message) ? '#4caf50' : '#94a3b8'">
                        {{ estaSelecionada(message) ? "mdi-checkbox-marked-circle" : "mdi-checkbox-blank-circle-outline" }}
                      </v-icon>
                    </span>
                    <div
                      class="message-bubble has-actions"
                      :class="{ 'message-highlight': highlightedMessageId === message.id }"
                      :style="{
                        position: 'relative',
                        paddingRight: modoSelecao || message.excluida ? null : '44px', 
                        pointerEvents: modoSelecao ? 'none' : null,
                      }"
                    >
                      <v-menu
                        v-if="!modoSelecao && !message.excluida"
                        offset-y
                        left
                        min-width="180"
                        content-class="message-actions-menu"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <button
                            type="button"
                            class="message-actions-btn"
                            :style="estiloBotaoAcoes(message)"
                            title="Mais ações"
                            aria-label="Mais ações"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon size="18" color="white">mdi-dots-vertical</v-icon>
                          </button>
                        </template>
                        <v-list dense>
                          <v-list-item
                            v-if="!isConversaSistema"
                            @click="iniciarResposta(message)"
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon small>mdi-reply</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Responder</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="copiarMensagem(message)">
                            <v-list-item-icon class="mr-3">
                              <v-icon small>mdi-content-copy</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Copiar</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="podeSelecionarMensagem(message)"
                            @click="encaminharMensagemUnica(message)"
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon small>mdi-share</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Encaminhar</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="podeSelecionarMensagem(message)"
                            @click="iniciarSelecao(message)"
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon small>mdi-checkbox-multiple-marked-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Selecionar mensagens</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="podeExcluirMensagem(message)"
                            @click="confirmarExclusaoMensagem(message)"
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon small color="error">mdi-delete-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="error--text">Excluir</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>

                      <div
                        class="message-sender"
                        :style="{
                          color: getSendColor(message.idRemetente),
                          display: 'block',
                          minWidth: 0,
                          maxWidth: '100%',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }"
                        :title="message.nomeRemetente"
                        v-if="
                          message.idRemetente !== currentUser.id &&
                          selectedConversation &&
                          (selectedConversation.tipo === 'GRUPO' ||
                            message.tipo === 'SISTEMA_NOTIFICACAO')
                        "
                      >
                        {{ message.nomeRemetente }}
                      </div>

                      <div
                        v-if="message.encaminhada && !message.excluida"
                        class="message-forwarded-header"
                        :style="estiloCabecalhoEncaminhada(message)"
                      >
                        <v-icon
                          size="14"
                          :color="ehMensagemPropria(message) ? 'white' : '#64748b'"
                          style="margin-right: 6px"
                        >mdi-share</v-icon>
                        <span :style="{ fontStyle: 'italic', marginRight: '4px', opacity: 0.85 }">Encaminhada de</span>
                        <span :style="{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }">
                          {{ autorEncaminhada(message) }}
                        </span>
                        <span
                          v-if="message.encaminhadaDeData"
                          :style="{ whiteSpace: 'nowrap', marginLeft: '4px', opacity: 0.85 }"
                        >· {{ formatarDataEncaminhada(message.encaminhadaDeData) }}</span>
                      </div>

                      <div
                        v-if="message.replyTo && !message.excluida"
                        class="message-reply-preview"
                        :style="estiloCitacao(message)"
                        role="button"
                        tabindex="0"
                        :title="message.replyTo.removida ? '' : 'Ir para a mensagem original'"
                        @click="irParaMensagemCitada(message.replyTo)"
                        @keyup.enter="irParaMensagemCitada(message.replyTo)"
                      >
                        <div
                          v-if="message.replyTo.removida"
                          :style="estiloCitacaoTexto(message, true)"
                        >
                          <v-icon x-small :color="corCitacaoTexto(message)" class="mr-1">mdi-cancel</v-icon>
                          Mensagem removida
                        </div>
                        <template v-else>
                          <div :style="estiloCitacaoAutor(message)">
                            {{ nomeAutorResposta(message.replyTo) }}
                          </div>
                          <div :style="estiloCitacaoTexto(message)">
                            <v-icon
                              v-if="message.replyTo.tipo === 'ARQUIVO'"
                              x-small
                              :color="corCitacaoTexto(message)"
                              class="mr-1"
                            >mdi-paperclip</v-icon>
                            {{ textoPreviewResposta(message.replyTo) }}
                          </div>
                        </template>
                      </div>

                      <div
                        v-if="message.excluida"
                        class="message-text"
                        :style="estiloMensagemApagada(message)"
                      >
                        <v-icon
                          small
                          :color="corMensagemApagada(message)"
                          class="mr-1"
                        >mdi-cancel</v-icon>
                        Mensagem apagada
                      </div>

                      <!-- Conteúdo de Arquivo -->
                      <div
                        v-else-if="message.tipo === 'ARQUIVO'"
                        class="message-file-content"
                      >
                        <!-- PREVIEW -->
                        <!-- Áudio Preview -->
                        <div
                          v-if="isAudio(message.tipoArquivo)"
                          class="audio-preview"
                        >
                          <iframe
                            :src="getFileUrl(message.conteudo, 'preview')"
                            class="audio-player"
                          ></iframe>
                        </div>

                        <!-- Outros arquivos com preview -->
                        <div
                          v-else-if="isPreview(message.nomeArquivo)"
                          class="file-preview"
                        >
                          <iframe
                            :src="getFileUrl(message.conteudo, 'preview')"
                            class="preview-pdf"
                          ></iframe>
                        </div>

                        <!-- CARD DO ARQUIVO -->
                        <div
                          class="file-card d-flex align-center"
                          v-if="!isAudio(message.tipoArquivo)"
                        >
                          <v-icon
                            size="36"
                            :color="getFileIconColor(message, '#f3f6fa')"
                            class="mr-3"
                          >
                            {{ getFileIcon(message.nomeArquivo) }}
                          </v-icon>

                          <div class="file-details flex-grow-1">
                            <div class="file-name">
                              {{ truncate(message.nomeArquivo, 20, true) }}
                            </div>
                            <div class="file-size">
                              {{
                                message.tamanhoArquivo
                                  ? formatFileSize(message.tamanhoArquivo)
                                  : ""
                              }}
                            </div>
                          </div>

                          <!-- AÇÕES -->
                          <div class="file-actions">
                            <v-btn
                              icon
                              small
                              :href="getFileUrl(message.conteudo, 'view')"
                              target="_blank"
                              title="Visualizar"
                              class="btn"
                            >
                              <v-icon size="18">mdi-eye</v-icon>
                            </v-btn>

                            <v-btn
                              icon
                              small
                              :href="getFileUrl(message.conteudo, 'download')"
                              target="_blank"
                              title="Baixar"
                              class="btn"
                            >
                              <v-icon size="18">mdi-download</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>

                      <!-- Conteúdo de texto normal -->
                      <div
                        v-else
                        class="message-text"
                        v-html="formatarMensagem(message.conteudo)"
                      ></div>

                      <div class="message-meta">
                        <span class="message-time">{{
                          formatMessageDateTime(message.dataEnvio)
                        }}</span>
                        <span
                          v-if="message.idRemetente === currentUser.id"
                          class="message-status"
                          @click="showReadByMenu(message)"
                        >
                          <v-icon
                            size="16"
                            :color="message.lida ? 'blue' : 'white'"
                          >
                            {{ message.lida ? "mdi-check-all" : "mdi-check" }}
                          </v-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <!-- Estado Vazio de Mensagens -->
            <div class="messages-container empty" v-else>
              <div class="empty-messages">
                <div class="empty-icon-wrapper">
                  <v-icon size="64" color="#4caf50"
                    >mdi-message-text-outline</v-icon
                  >
                </div>
                <h3>{{ isConversaSistema ? "Nenhuma notificação ainda" : "Nenhuma mensagem ainda" }}</h3>
                <p>
                  {{
                    isConversaSistema
                      ? "As notificações automáticas aparecerão aqui."
                      : "Envie a primeira mensagem para iniciar a conversa"
                  }}
                </p>
              </div>
            </div>

            <button
              v-if="novasMensagensNaoVistas > 0"
              type="button"
              class="btn-novas-mensagens"
              title="Novas mensagens"
              @click="irParaNovasMensagens"
            >
              <span class="btn-novas-mensagens-badge">
                {{ novasMensagensNaoVistas > 99 ? "99+" : novasMensagensNaoVistas }}
              </span>
              <v-icon color="#334155">mdi-chevron-down</v-icon>
            </button>
            </div>

            <!-- Input de Mensagem -->
            <div
              v-if="modoSelecao"
              class="message-input-area selection-bar"
              :style="{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 24px',
              }"
            >
              <v-btn icon small title="Cancelar seleção" @click="cancelarSelecao">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span :style="{ fontWeight: 600, color: '#1e293b', flex: 1 }">
                {{ quantidadeSelecionadas }}
                {{ quantidadeSelecionadas === 1 ? "selecionada" : "selecionadas" }}
              </span>
              <v-btn text small color="#64748b" @click="cancelarSelecao">
                Cancelar seleção
              </v-btn>
              <v-btn
                small
                color="#4caf50"
                class="white--text"
                :disabled="quantidadeSelecionadas === 0"
                @click="abrirDialogEncaminhar"
              >
                <v-icon left small>mdi-share</v-icon>
                Encaminhar
              </v-btn>
            </div>

            <div v-else-if="isConversaSistema" class="message-input-area system-readonly">
              <v-icon size="18" color="#64748b">mdi-information-outline</v-icon>
              <span>Somente o sistema pode enviar mensagens.</span>
            </div>

            <div v-else class="message-input-area">
              <div class="input-toolbar">
                <div class="format-buttons">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        v-on="on"
                        @click="formatar('bold')"
                        class="btn"
                      >
                        <v-icon size="18">mdi-format-bold</v-icon>
                      </v-btn>
                    </template>
                    <span>Negrito</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        v-on="on"
                        @click="formatar('italic')"
                        class="btn"
                      >
                        <v-icon size="18">mdi-format-italic</v-icon>
                      </v-btn>
                    </template>
                    <span>Itálico</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        v-on="on"
                        @click="formatar('underline')"
                        class="btn"
                      >
                        <v-icon size="18">mdi-format-underline</v-icon>
                      </v-btn>
                    </template>
                    <span>Sublinhado</span>
                  </v-tooltip>

                  <div class="toolbar-divider"></div>

                  <v-menu
                    v-model="showEmojiPicker"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" class="btn">
                        <v-icon size="18">mdi-emoticon-happy-outline</v-icon>
                      </v-btn>
                    </template>
                    <div class="emoji-picker-wrapper">
                      <emoji-picker
                        @emoji-click="onEmojiClick"
                        class="light"
                      ></emoji-picker>
                    </div>
                  </v-menu>

                  <v-btn icon small class="btn" @click="abrirDialogAnexo">
                    <v-icon size="18">mdi-attachment</v-icon>
                  </v-btn>

                  <v-btn icon small class="btn" @click="abrirDialogAudio">
                    <v-icon size="18">mdi-microphone</v-icon>
                  </v-btn>

                  <v-dialog
                    v-model="dialogAnexo"
                    max-width="600"
                    persistent
                    :retain-focus="false"
                  >
                    <v-card>
                      <v-card-title class="dialog-header">
                        Adicione um arquivo para enviar
                      </v-card-title>
                      <v-card-text class="dialog-content pt-6">
                        <v-file-input
                          v-model="anexoFiles"
                          label="Selecione um ou mais arquivos"
                          outlined
                          small
                          dense
                          multiple
                          chips
                          small-chips
                          :rules="[
                            (v) =>
                              (Array.isArray(v) && v.length > 0) ||
                              'Selecione ao menos um arquivo',
                            (v) =>
                              !v ||
                              !v.some((file) => file.size > 10000000) ||
                              'Cada arquivo deve ter menos de 10MB',
                          ]"
                          accept=".png, .jpg, .jpeg, .gif, .webp, .pdf, .doc, .docx, .xls, .xlsx, .csv, .txt"
                          @change="handleAnexoFilesChange"
                        ></v-file-input>

                        <input
                          ref="addAnexoInput"
                          type="file"
                          multiple
                          accept=".png, .jpg, .jpeg, .gif, .webp, .pdf, .doc, .docx, .xls, .xlsx, .csv, .txt"
                          style="display: none"
                          @change="handleAddAnexoFiles"
                        />
                        <div
                          v-if="anexoFiles.length"
                          class="d-flex justify-end"
                        >
                          <v-btn
                            small
                            outlined
                            color="primary"
                            :disabled="enviandoArquivo"
                            @click="$refs.addAnexoInput.click()"
                          >
                            <v-icon small left>mdi-plus</v-icon>
                            Adicionar arquivo
                          </v-btn>
                        </div>

                        <div v-if="anexoFiles.length" class="mt-4">
                          <v-alert type="info" outlined>
                            <strong>Arquivos:</strong>
                            {{ anexoFiles.length }}<br />
                            <strong>Tamanho total:</strong>
                            {{ formatFileSize(totalAnexoFilesSize) }}
                          </v-alert>
                          <v-list dense class="py-0">
                            <v-list-item
                              v-for="file in anexoFiles"
                              :key="`${file.name}-${file.size}-${file.lastModified}`"
                              class="px-0"
                            >
                              <v-list-item-icon class="mr-2">
                                <v-icon small color="primary">
                                  {{ getFileIcon(file.name) }}
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="caption">
                                  {{ truncate(file.name, 50, true) }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ formatFileSize(file.size) }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action class="my-0">
                                <v-btn
                                  icon
                                  x-small
                                  :disabled="enviandoArquivo"
                                  @click="removerAnexoFile(file)"
                                >
                                  <v-icon small>mdi-close</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                          <div v-if="enviandoArquivo" class="caption mt-2">
                            Enviando {{ enviandoArquivoIndex }} de
                            {{ anexoFiles.length }}
                          </div>
                        </div>
                        <v-expansion-panels
                          v-if="isPdf(anexoFile) || isImage(anexoFile)"
                          class="mb-4"
                          flat
                          :value="-1"
                        >
                          <v-expansion-panel class="expansion-panel">
                            <v-expansion-panel-header class="pb-0">
                              <div class="d-flex align-center">
                                <v-icon left color="primary"
                                  >mdi-eye-outline</v-icon
                                >
                                <span class="font-weight-medium"
                                  >Previsualização</span
                                >
                              </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card
                                outlined
                                class="pa-2 d-flex flex-column align-center"
                              >
                                <!-- HEADER -->
                                <div
                                  class="d-flex justify-space-between align-center mb-2"
                                >
                                  <div
                                    class="text-subtitle-2 font-weight-medium text-truncate mr-2"
                                  >
                                    {{ truncate(anexoFile.name, 30, true) }}
                                  </div>

                                  <v-chip x-small color="grey lighten-2">
                                    {{ formatFileSize(anexoFile.size) }}
                                  </v-chip>
                                </div>

                                <!-- IMAGEM -->
                                <v-img
                                  v-if="isImage(anexoFile)"
                                  :src="filePreviewUrl(anexoFile)"
                                  max-height="180"
                                  contain
                                  class="rounded"
                                />

                                <!-- PDF -->
                                <iframe
                                  v-else-if="isPdf(anexoFile)"
                                  :src="filePreviewUrl(anexoFile)"
                                  class="preview-pdf"
                                ></iframe>

                                <!-- OUTROS -->
                                <v-alert
                                  v-else
                                  dense
                                  outlined
                                  type="info"
                                  class="mt-2"
                                >
                                  Não é possível visualizar este tipo de arquivo
                                  <br />
                                  <strong>{{ anexoFile.type }}</strong>
                                </v-alert>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card-text>
                      <v-card-actions class="dialog-actions">
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="dialogAnexo = false"
                          small
                          color="#4caf50"
                          >Cancelar</v-btn
                        >
                        <v-btn
                          color="#4caf50"
                          @click="enviarArquivo"
                          :disabled="!anexoFiles.length || hasInvalidAnexoFiles"
                          :loading="enviandoArquivo"
                          small
                          class="pr-5"
                        >
                          <v-icon left small>mdi-send</v-icon>
                          Enviar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </div>

              <div v-if="replyingTo" class="reply-bar">
                <div
                  class="reply-bar-content"
                  :style="{ borderLeftColor: getSendColor(replyingTo.idRemetente) }"
                >
                  <div
                    class="message-reply-author"
                    :style="{ color: getSendColor(replyingTo.idRemetente) }"
                  >
                    Respondendo a {{ nomeAutorResposta(replyingTo) }}
                  </div>
                  <div class="message-reply-text">
                    <v-icon v-if="replyingTo.tipo === 'ARQUIVO'" x-small class="mr-1">mdi-paperclip</v-icon>
                    {{ textoPreviewResposta(replyingTo) }}
                  </div>
                </div>
                <v-btn icon small title="Cancelar resposta" @click="cancelarResposta">
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </div>

              <div class="input-container">
                <v-textarea
                  id="textareaRef"
                  v-model="newMessage"
                  placeholder="Digite sua mensagem..."
                  rows="1"
                  hide-details
                  solo
                  flat
                  dense
                  auto-grow
                  class="message-textarea"
                  @keyup.enter="handleEnter"
                  @paste="handlePasteImage"
                  :disabled="!isConnected"
                />
                <v-btn
                  fab
                  small
                  color="#4caf50"
                  class="send-button"
                  @click="sendMessage"
                  :disabled="!newMessage || !isConnected"
                >
                  <v-icon color="white">mdi-send</v-icon>
                </v-btn>
              </div>
            </div>
          </template>

          <!-- Estado sem Conversa Selecionada -->
          <template v-else>
            <div class="no-conversation-selected">
              <div class="welcome-illustration">
                <div class="illustration-circles">
                  <div class="circle circle-1"></div>
                  <div class="circle circle-2"></div>
                  <div class="circle circle-3"></div>
                </div>
                <v-icon size="80" color="#4caf50">mdi-forum</v-icon>
              </div>
              <h2>Bem-vindo ao Chat</h2>
              <p>Selecione uma conversa para começar ou crie uma nova</p>
            </div>
          </template>
        </div>
      </div>

      <div v-else-if="shouldShowConnectionError" class="chat-disconnected-page">
        <div class="chat-disconnected-panel">
          <div class="chat-disconnected-icon">
            <v-icon size="48" color="#ef4444">mdi-wifi-off</v-icon>
          </div>
          <span class="chat-disconnected-label">Chat desconectado</span>
          <h2>Não foi possível conectar ao servidor de mensagens</h2>
          <p>
            Estamos tentando reconectar automaticamente. As conversas voltarão
            para a tela assim que a conexão for restabelecida.
          </p>

          <div class="chat-retry-status">
            <v-progress-circular
              indeterminate
              size="20"
              width="2"
              color="#4caf50"
            />
            <span>{{ reconnectStatusMessage }}</span>
          </div>

          <v-btn
            color="#4caf50"
            class="chat-retry-button"
            :disabled="isReconnectingNow"
            @click="retryWebSocketNow"
          >
            <v-icon left small>mdi-refresh</v-icon>
            Tentar agora
          </v-btn>
        </div>
      </div>

      <div v-else class="chat-connecting-page">
        <div class="chat-connecting-panel">
          <div class="chat-connecting-icon">
            <v-icon size="42" color="#4caf50">mdi-forum-outline</v-icon>
          </div>
          <h2>Conectando ao chat</h2>
          <p>Preparando suas conversas...</p>
          <div class="chat-connecting-progress">
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Diálogo de Visualizações -->
    <v-dialog v-model="activeReadByMenu" max-width="400" persistent>
      <v-card class="views-dialog">
        <v-card-title class="dialog-header"> Visualizações </v-card-title>
        <v-card-text class="dialog-content">
          <div
            v-if="
              activeMessage &&
              activeMessage.leitoPor &&
              activeMessage.leitoPor.length > 0
            "
          >
            <div
              v-for="(leitor, index) in activeMessage.leitoPor"
              :key="index"
              class="viewer-item"
            >
              <div class="viewer-avatar" :class="getAvatarColor(index)">
                {{ getInitials(leitor.nomeUsuario) }}
              </div>
              <div class="viewer-info">
                <span class="viewer-name">{{ leitor.nomeUsuario }}</span>
                <span class="viewer-time">
                  <v-icon small>mdi-clock-outline</v-icon>
                  {{ formatDateTime(leitor.dataLeitura) }}
                </span>
              </div>
            </div>
          </div>
          <div v-else class="no-viewers">
            <v-icon size="48" color="#cbd5e1">mdi-eye-off</v-icon>
            <p>Ninguém visualizou ainda</p>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text color="#4caf50" @click="activeReadByMenu = false" small
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Nova Conversa -->
    <v-dialog
      v-model="showStartConversationDialog"
      max-width="640px"
      persistent
    >
      <v-card class="new-conversation-dialog" rounded="lg">
        <v-card-title class="dialog-header"> Iniciar nova conversa </v-card-title>
        <v-card-text class="dialog-content pt-6">
          <v-autocomplete
            v-model="selectedStartUserId"
            :items="listUserComDepartamento"
            item-text="nome"
            item-value="id"
            label="Selecione os participantes"
            outlined
            dense
            chips
            small-chips
            deletable-chips
            :loading="loadingUsers"
            no-data-text="Nenhum usuário encontrado"
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.nome }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.cargo">
                  {{ item.cargo }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>

          <v-textarea
            v-model="initialMessage"
            label="Mensagem"
            outlined
            dense
            auto-grow
            rows="3"
            counter="3000"
            :rules="[(v) => !!(v && v.trim()) || 'Mensagem obrigatoria']"
            @keydown.enter.exact.prevent="startPrivateConversation"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeStartConversationDialog"
            small
            color="#4caf50"
            >Cancelar</v-btn
          >
          <v-btn
            color="#4caf50"
            @click="startPrivateConversation"
            :disabled="!isStartConversationValid || startingConversation"
            :loading="startingConversation"
            small
            class="pr-5"
          >
            <v-icon left small>mdi-send</v-icon>
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Encaminhar -->
    <v-dialog v-model="showEncaminharDialog" max-width="640px" persistent>
      <v-card class="new-conversation-dialog" rounded="lg">
        <v-card-title class="dialog-header">
          Encaminhar {{ idsParaEncaminhar.length }}
          {{ idsParaEncaminhar.length === 1 ? "mensagem" : "mensagens" }}
        </v-card-title>
        <v-card-text class="dialog-content pt-6">
          <v-autocomplete
            v-model="destinatariosEncaminhar"
            :items="listUserComDepartamento"
            item-text="nome"
            item-value="id"
            label="Selecione os destinatários"
            outlined
            dense
            multiple
            chips
            small-chips
            deletable-chips
            clearable
            :loading="loadingUsers"
            no-data-text="Nenhum usuário encontrado"
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.nome }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.cargo">
                  {{ item.cargo }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <div :style="{ fontSize: '12px', color: '#64748b', marginTop: '-8px' }">
            Cada pessoa recebe as mensagens na sua própria conversa individual (não é criado um grupo).
          </div>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            small
            color="#4caf50"
            :disabled="encaminhando"
            @click="fecharDialogEncaminhar"
          >Cancelar</v-btn>
          <v-btn
            color="#4caf50"
            small
            class="pr-5 white--text"
            :disabled="destinatariosEncaminhar.length === 0 || encaminhando"
            :loading="encaminhando"
            @click="confirmarEncaminhamento"
          >
            <v-icon left small>mdi-share</v-icon>
            Encaminhar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showNewConversationDialog" max-width="600px" persistent>
      <v-card class="new-conversation-dialog" rounded="lg">
        <v-card-title class="dialog-header"> Novo Grupo </v-card-title>
        <v-card-text class="dialog-content pt-6">
          <v-text-field
            v-model="groupName"
            label="Nome do grupo"
            outlined
            dense
            :rules="[(v) => !!v || 'Nome do grupo é obrigatório']"
          >
          </v-text-field>

          <v-autocomplete
            v-model="selectedParticipants"
            :items="listUserComDepartamento"
            item-text="nome"
            item-value="id"
            label="Selecione um usuario"
            outlined
            dense
            clearable
            multiple
            :loading="loadingUsers"
            no-data-text="Nenhum usuario encontrado"
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.nome }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.cargo">
                  {{ item.cargo }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 3" small color="#4caf50" dark class="ma-1">
                {{ item.nome }}
                <span v-if="item.cargo"></span>
              </v-chip>
              <span v-if="index === 3" class="grey--text text-caption ml-1">
                (+{{ selectedParticipants.length - 3 }} outros)
              </span>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showNewConversationDialog = false"
            small
            color="#4caf50"
            >Cancelar</v-btn
          >
          <v-btn
            color="#4caf50"
            @click="createNewConversation"
            :disabled="!isFormValid || creatingConversation"
            :loading="creatingConversation"
            small
            class="pr-5"
          >
            <v-icon left small>mdi-plus</v-icon>
            Criar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Gerenciar Membros -->
    <v-dialog v-model="showManageMembersDialog" max-width="700px" persistent>
      <v-card class="manage-members-dialog" rounded="lg">
        <v-card-title class="dialog-header">
          {{
            selectedConversation
              ? selectedConversation.nomeChat
              : "Membros do Grupo"
          }}
        </v-card-title>
        <v-card-text class="dialog-content pt-4">
          <!-- Área de carregamento -->
          <div v-if="loadingParticipants" class="text-center py-4">
            <v-progress-circular
              indeterminate
              color="#4caf50"
            ></v-progress-circular>
            <div class="mt-2">Carregando membros...</div>
          </div>

          <!-- Área de editar nome do grupo (apenas para admin/proprietário) -->
          <div
            v-if="
              canManageMembers &&
              selectedConversation &&
              selectedConversation.tipo === 'GRUPO'
            "
            class="mb-5"
          >
            <h3 class="subtitle-1 mb-3">Editar nome do grupo</h3>
            <div class="d-flex align-center">
              <v-text-field
                v-model="groupNameEdit"
                label="Nome do grupo"
                outlined
                dense
                hide-details
                class="flex-grow-1 mr-2"
                :placeholder="selectedConversation.nomeChat"
              ></v-text-field>
              <v-btn
                icon
                small
                class="primary-action"
                :disabled="
                  !groupNameEdit ||
                  groupNameEdit.trim() === '' ||
                  editingGroupName
                "
                :loading="editingGroupName"
                @click="editGroupName"
                title="Salvar nome do grupo"
              >
                <v-icon size="18">mdi-content-save</v-icon>
              </v-btn>
            </div>
            <v-divider class="my-4"></v-divider>
          </div>

          <!-- Área de adicionar membros (apenas para admin/proprietário) -->
          <div v-if="canManageMembers" class="mb-5">
            <h3 class="subtitle-1 mb-3">Adicionar membros</h3>
            <div class="d-flex align-center">
              <v-autocomplete
                v-model="selectedNewMembers"
                :items="availableUsers"
                item-text="nome"
                item-value="id"
                label="Selecione usuários para adicionar"
                outlined
                dense
                chips
                small-chips
                multiple
                hide-details
                deletable-chips
                :loading="loadingUsers"
                no-data-text="Nenhum usuário encontrado"
                class="flex-grow-1 mr-2"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < 3"
                    small
                    color="#4caf50"
                    dark
                    class="ma-1"
                  >
                    {{ item.nome }}
                  </v-chip>
                  <span v-if="index === 3" class="grey--text text-caption ml-1">
                    (+{{ selectedNewMembers.length - 3 }} outros)
                  </span>
                </template>
              </v-autocomplete>
              <v-btn
                icon
                small
                class="primary-action"
                :disabled="selectedNewMembers.length === 0 || addingMembers"
                :loading="addingMembers"
                @click="addMembers"
                title="Adicionar membros"
              >
                <v-icon size="18">mdi-account-plus</v-icon>
              </v-btn>
            </div>
            <v-divider class="my-4"></v-divider>
          </div>

          <!-- Lista de membros -->
          <h3 class="subtitle-1">Membros do grupo</h3>
          <div v-if="participants.length === 0" class="text-center py-4">
            <v-icon size="48" color="#cbd5e1">mdi-account-group</v-icon>
            <div class="mt-2">Nenhum membro encontrado</div>
          </div>

          <div v-else>
            <v-list>
              <v-list-item
                v-for="participant in participants"
                :key="participant.id"
                class="member-item"
              >
                <v-list-item-avatar>
                  <div
                    class="avatar-circle"
                    :class="getAvatarColor(participant.idParticipante)"
                  >
                    {{ getInitials(participant.nomeParticipante) }}
                  </div>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="d-flex align-center">
                    {{ participant.nomeParticipante }}

                    <v-icon
                      v-if="participant.proprietario"
                      small
                      color="amber"
                      class="ml-1"
                      >mdi-star</v-icon
                    >
                    <v-chip
                      v-if="participant.admin && !participant.proprietario"
                      x-small
                      outlined
                      color="#4caf50"
                      class="ml-2"
                      >Admin</v-chip
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                    <div>
                      <v-icon
                        :color="
                          getStatusIcon(
                            getStatusParticipant(participant.idParticipante),
                          ).color
                        "
                        size="14"
                      >
                        {{
                          getStatusIcon(
                            getStatusParticipant(participant.idParticipante),
                          ).icon
                        }}
                      </v-icon>
                      {{ getStatusParticipant(participant.idParticipante) }}
                    </div>
                    Adicionado em {{ formatDate(participant.dataInclusao) }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action
                  v-if="
                    canManageMembers &&
                    participant.idParticipante !== currentUser.id
                  "
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon x-small v-bind="attrs" v-on="on" class="btn">
                        <v-icon small>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                        v-if="isGroupOwner && !participant.admin"
                        @click="promoteToAdmin(participant.idParticipante)"
                      >
                        <v-list-item-title
                          >Promover a administrador</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="
                          isGroupOwner &&
                          participant.admin &&
                          !participant.proprietario
                        "
                        @click="demoteFromAdmin(participant.idParticipante)"
                      >
                        <v-list-item-title
                          >Remover de administrador</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="isGroupOwner"
                        @click="
                          confirmTransferOwnership(participant.idParticipante)
                        "
                      >
                        <v-list-item-title
                          >Transferir propriedade</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="canManageMembers"
                        @click="confirmRemoveMember(participant.idParticipante)"
                      >
                        <v-list-item-title class="error--text"
                          >Remover do grupo</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text color="#4caf50" @click="fecharDialogGrupo()" small>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação -->
    <v-dialog
      v-model="confirmDialog.show"
      max-width="400px"
      @input="onConfirmDialogInput"
    >
      <v-card>
        <v-card-title class="dialog-header">
          {{ confirmDialog.title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 confirm-dialog-message">
          <div class="confirm-dialog-body">
            {{ confirmDialog.message }}
          </div>
          <div
            v-if="confirmDialog.confirmDelayRemaining > 0"
            class="confirm-delay-hint mt-4"
          >
            <v-icon small left color="#b45309">mdi-timer-outline</v-icon>
            Leia o aviso com atenção. A confirmação será liberada em
            <strong>{{ confirmDialog.confirmDelayRemaining }}s</strong>.
          </div>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text small @click="closeConfirmDialog">Cancelar</v-btn>
          <v-btn
            :color="confirmDialog.color"
            @click="confirmDialog.action"
            :loading="confirmDialog.loading"
            :disabled="
              confirmDialog.loading || confirmDialog.confirmDelayRemaining > 0
            "
            small
            depressed
          >
            <v-icon left small v-if="confirmDialog.closesGroup">
              mdi-close-circle-outline
            </v-icon>
            {{
              confirmDialog.confirmDelayRemaining > 0
                ? `${confirmDialog.confirmText} (${confirmDialog.confirmDelayRemaining})`
                : confirmDialog.confirmText
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Gravação de Áudio -->
    <v-dialog v-model="dialogAudio" max-width="500" persistent>
      <v-card>
        <v-card-title class="dialog-header">
          <span>{{
            isRecording ? "Gravando áudio..." : "Gravar mensagem de áudio"
          }}</span>
        </v-card-title>

        <v-card-text class="pa-4 text-center">
          <!-- Solicitar permissão -->
          <div v-if="permissaoMicrofone === null" class="my-4">
            <v-icon size="64" color="#4caf50" class="mb-4"
              >mdi-microphone</v-icon
            >
            <div class="title mb-2">Permissão para usar o microfone</div>
            <div class="subtitle-1 grey--text mb-4">
              Para gravar áudio, precisamos da sua permissão para acessar o
              microfone.
            </div>
            <v-btn
              color="#4caf50"
              @click="solicitarPermissaoMicrofone"
              :loading="solicitandoPermissao"
            >
              <v-icon left>mdi-microphone</v-icon>
              Permitir acesso
            </v-btn>
          </div>

          <!-- Permissão negada -->
          <div v-else-if="permissaoMicrofone === false" class="my-4">
            <v-icon size="64" color="red" class="mb-4"
              >mdi-microphone-off</v-icon
            >
            <div class="title mb-2">Permissão negada</div>
            <div class="subtitle-1 grey--text mb-4">
              Você não permitiu o acesso ao microfone. Para gravar áudio, é
              necessário permitir o acesso nas configurações do seu navegador.
            </div>
          </div>

          <!-- Gravador de áudio -->
          <div v-else class="audio-recorder-container">
            <div
              class="audio-visualizer mb-4"
              :class="{ 'is-recording': isRecording }"
            >
              <div class="time-counter">
                {{ formatAudioTime(audioDuration) }}
              </div>
              <div class="wave-container">
                <div class="wave" v-for="n in 5" :key="n"></div>
              </div>
            </div>

            <!-- Botões de controle -->
            <div class="audio-controls">
              <!-- Botão de gravação -->
              <v-btn
                v-if="!isRecording && !audioBlob"
                fab
                color="#4caf50"
                @click="iniciarGravacao"
                class="mx-2"
              >
                <v-icon>mdi-microphone</v-icon>
              </v-btn>

              <!-- Botão de parar -->
              <v-btn
                v-if="isRecording"
                fab
                color="red"
                @click="pararGravacao"
                class="mx-2"
              >
                <v-icon>mdi-stop</v-icon>
              </v-btn>

              <!-- Player de áudio (após gravar) -->
              <audio
                v-if="audioURL && !isRecording"
                controls
                :src="audioURL"
                class="audio-preview-player mb-3"
              ></audio>

              <!-- Botões após gravar -->
              <div
                v-if="audioBlob && !isRecording"
                class="d-flex justify-center mt-3"
              >
                <v-btn
                  text
                  color="error"
                  @click="descartarAudio"
                  class="mx-2"
                  small
                >
                  <v-icon left>mdi-delete</v-icon>
                  Descartar
                </v-btn>

                <v-btn
                  color="#4caf50"
                  @click="enviarAudio"
                  :loading="enviandoAudio"
                  class="mx-2"
                  small
                >
                  <v-icon left>mdi-send</v-icon>
                  Enviar
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#4caf50" @click="fecharDialogAudio"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Arquivos Compartilhados -->
    <v-dialog v-model="dialogListaArquivos" max-width="700" persistent>
      <v-card>
        <v-card-title class="dialog-header">
          <span>Arquivos Compartilhados</span>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-skeleton-loader
            v-if="listaArquivos.length === 0"
            type="list-item-three-line, list-item-three-line"
          ></v-skeleton-loader>

          <v-alert v-else-if="listaArquivos.length === 0" type="info" outlined>
            Nenhum arquivo foi compartilhado nesta conversa.
          </v-alert>

          <v-list v-else three-line>
            <v-list-item
              v-for="arquivo in listaArquivos"
              :key="arquivo.id"
              class="mb-2"
              v-if="!isAudio(arquivo.tipoArquivo)"
            >
              <v-list-item-avatar>
                <v-icon size="40" :color="getFileIconColor(arquivo, 'grey')">
                  {{ getFileIcon(arquivo.nomeArquivo) }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{
                  getFileName(arquivo.conteudo)
                }}</v-list-item-title>
                <v-list-item-subtitle>
                  Enviado por {{ arquivo.nomeRemetente }} em
                  {{ formatMessageDateTime(arquivo.dataEnvio) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action class="d-flex align-center flex-row">
                <v-btn
                  class="btn"
                  icon
                  color="primary"
                  :href="getFileUrl(arquivo.conteudo, 'download')"
                  target="_blank"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-btn
                  class="btn"
                  icon
                  color="primary"
                  :href="getFileUrl(arquivo.conteudo, 'view')"
                  target="_blank"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#4caf50" @click="dialogListaArquivos = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showChatSettingsDialog" max-width="560px">
      <v-card class="chat-settings-dialog" rounded="lg">
        <v-card-title class="dialog-header chat-settings-header">
          <v-icon color="white" class="mr-3">mdi-cog-outline</v-icon>
          <div>
            <div>Configurações do bate-papo</div>
          </div>
        </v-card-title>

        <v-card-text class="dialog-content chat-settings-content">
          <div class="chat-settings-section">
            <div class="chat-settings-section-heading">
              <div class="chat-settings-section-icon">
                <v-icon size="21" color="#2e7d32">mdi-bell-outline</v-icon>
              </div>
              <div>
                <div class="chat-settings-section-title">
                  Avisos de novas mensagens
                </div>
                <div class="chat-settings-section-description">
                  Defina o que acontece quando uma nova mensagem chegar.
                </div>
              </div>
            </div>

            <v-select
              v-model="chatSettings.modoNotificacao"
              :items="notificationModeOptions"
              label="Como você quer ser avisado?"
              item-text="text"
              item-value="value"
              outlined
              :loading="loadingChatSettings"
              :disabled="savingChatSettings"
              hide-details
              @change="saveChatSettings"
            />
          </div>

          <div
            class="chat-settings-section"
            :class="{
              'chat-settings-section--disabled': !notificationPlaysSound,
            }"
          >
            <div class="chat-settings-section-heading">
              <div class="chat-settings-section-icon">
                <v-icon size="21" color="#2e7d32">mdi-volume-high</v-icon>
              </div>
              <div>
                <div class="chat-settings-section-title">
                  Volume do som
                </div>
                <div class="chat-settings-section-description">
                  Ajuste a intensidade do alerta sonoro.
                </div>
              </div>
            </div>

            <v-select
              v-model="chatSettings.volumeNotificacao"
              :items="notificationVolumeOptions"
              label="Volume da notificação"
              item-text="text"
              item-value="value"
              outlined
              :loading="loadingChatSettings"
              :disabled="savingChatSettings || !notificationPlaysSound"
              hide-details
              @change="saveChatSettings"
            />
            <div
              v-if="!notificationPlaysSound"
              class="chat-settings-disabled-hint"
            >
              Ative o som da notificação para ajustar o volume.
            </div>
          </div>

          <div
            class="chat-settings-section"
            :class="{
              'chat-settings-section--disabled': !notificationShowsScreenAlert,
            }"
          >
            <div class="chat-settings-section-heading">
              <div class="chat-settings-section-icon">
                <v-icon size="21" color="#2e7d32">
                  mdi-message-alert-outline
                </v-icon>
              </div>
              <div>
                <div class="chat-settings-section-title">
                  Duração do aviso na tela
                </div>
                <div class="chat-settings-section-description">
                  Escolha por quanto tempo o aviso ficará visível.
                </div>
              </div>
            </div>

            <v-select
              v-model="chatSettings.tempoPopupMs"
              :items="popupTimeOptions"
              label="Tempo de exibição"
              item-text="text"
              item-value="value"
              outlined
              :loading="loadingChatSettings"
              :disabled="savingChatSettings || !notificationShowsScreenAlert"
              hide-details
              @change="saveChatSettings"
            />
            <div
              v-if="!notificationShowsScreenAlert"
              class="chat-settings-disabled-hint"
            >
              Ative o aviso na tela para escolher o tempo de exibição.
            </div>
          </div>

          <div class="chat-settings-section chat-settings-switch-section">
            <div class="chat-settings-section-heading mb-0">
              <div class="chat-settings-section-icon">
                <v-icon size="21" color="#2e7d32">
                  mdi-message-text-outline
                </v-icon>
              </div>
              <div class="chat-settings-switch-copy">
                <div class="chat-settings-section-title">
                  Atalho do bate-papo na tela
                </div>
                <div class="chat-settings-section-description">
                  Mostra um botão flutuante para abrir o bate-papo rapidamente.
                </div>
              </div>
              <v-switch
                v-model="chatSettings.exibirBotaoFlutuante"
                color="#4caf50"
                inset
                hide-details
                class="chat-settings-switch"
                :disabled="savingChatSettings"
                @change="saveChatSettings"
              />
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="dialog-actions chat-settings-actions">
          <span v-if="savingChatSettings" class="chat-settings-saving">
            <v-progress-circular
              indeterminate
              size="16"
              width="2"
              color="#4caf50"
              class="mr-2"
            />
            Salvando alterações...
          </span>
          <v-spacer />
          <v-btn text color="#2e7d32" @click="showChatSettingsDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLimiteMensagem" max-width="480px">
      <v-card>
        <v-card-title class="dialog-header">Limite de caracteres</v-card-title>
        <v-card-text class="pt-4">
          <p class="mb-3">
            Sua mensagem tem {{ formatarContagemCaracteres(limiteMensagemTotal) }}
            caracteres, mas o limite é
            {{ formatarContagemCaracteres(limiteMensagemCaracteres) }}. O texto foi
            cortado e só a primeira parte foi enviada.
          </p>
          <p class="mb-0">
            Copie o restante e envie em uma nova mensagem, se precisar.
          </p>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn color="#4caf50" text @click="dialogLimiteMensagem = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import batepapo from "@/services/batepapo";
import user from "../../services/usuario";
import "emoji-picker-element";

export default {
  name: "TestChat",

  data() {
    return {
      // Usuário atual
      currentUser: JSON.parse(sessionStorage.getItem("user")),

      // Conversas
      conversations: [],
      selectedConversation: null,
      selectedConversationIndex: -1,
      loadingConversations: false,
      searchQuery: "",

      // Mensagens
      messages: [],
      loadingMessages: false,
      loadingOlderMessages: false,
      isInitialLoad: false,
      hasMoreMessages: true,
      messagesPageSize: 50,
      newMessage: "",
      replyingTo: null,
      modoSelecao: false,
      mensagensSelecionadas: {},
      showEncaminharDialog: false,
      idsParaEncaminhar: [],
      destinatariosEncaminhar: [],
      encaminhando: false,
      highlightedMessageId: null,
      highlightTimer: null,
      dialogLimiteMensagem: false,
      limiteMensagemCaracteres: 3000,
      limiteMensagemTotal: 0,
      novasMensagensNaoVistas: 0,

      // WebSocket
      stompClient: null,
      isConnected: false,
      isReconnectingNow: false,
      websocketManuallyClosed: false,
      reconnectAttempts: 0,
      fastReconnectAttempts: 5,
      fastReconnectInterval: 5000,
      fallbackReconnectInterval: 60000,
      reconnectTimer: null,
      nextReconnectAt: null,
      lastConnectionError: "",
      pingInterval: null,
      websocketConnectionId: 0,
      currentSubscription: null,
      processedMessageIds: new Set(),
      readDebounceTimer: null,
      activeReadRequest: null,
      pendingConversationReads: {},
      lastReadMessageByConversation: {},

      // Nova conversa
      showStartConversationDialog: false,
      showNewConversationDialog: false,
      users: [],
      selectedUserId: null,
      selectedStartUserId: null,
      initialMessage: "",
      selectedParticipants: [],
      groupName: "",
      conversationTab: 0,
      loadingUsers: false,
      startingConversation: false,
      creatingConversation: false,

      // Snackbar
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },

      // Diálogo de leitura de mensagens
      activeReadByMenu: false,
      activeMessage: null,

      // Formatação de texto e emojis
      showEmojiPicker: false,

      // Anexos
      dialogAnexo: false,
      anexoFile: null,
      anexoFiles: [],
      enviandoArquivo: false,
      enviandoArquivoIndex: 0,
      listaArquivos: [],
      dialogListaArquivos: false,

      // Gravação de áudio
      dialogAudio: false,
      audioRecorder: null,
      isRecording: false,
      audioBlob: null,
      audioURL: null,
      audioDuration: 0,
      audioTimer: null,
      enviandoAudio: false,
      permissaoMicrofone: null,
      solicitandoPermissao: false,

      // Gerenciamento de membros
      showManageMembersDialog: false,
      participants: [],
      loadingParticipants: false,
      selectedNewMembers: [],
      loadingUsers: false,
      addingMembers: false,
      groupNameEdit: "",
      editingGroupName: false,
      changingAdminStatus: false,

      // Diálogo de confirmação
      confirmDialog: {
        show: false,
        title: "",
        message: "",
        confirmText: "Confirmar",
        color: "primary",
        action: () => {},
        loading: false,
        confirmDelayRemaining: 0,
        closesGroup: false,
      },
      confirmDelayTimer: null,

      // Status do usuário
      userStatus: "ONLINE",
      statusOptions: [
        { text: "Online", value: "ONLINE" },
        { text: "Ausente", value: "AUSENTE" },
        { text: "Ocupado", value: "OCUPADO" },
        { text: "Não perturbe", value: "NAO_PERTURBE" },
        { text: "Offline", value: "OFFLINE" },
      ],
      showChatSettingsDialog: false,
      loadingChatSettings: false,
      savingChatSettings: false,
      chatSettings: {
        modoNotificacao: "PREVIEW_E_SOM",
        exibirBotaoFlutuante: true,
        tempoPopupMs: 6000,
        volumeNotificacao: 80,
      },
      notificationModeOptions: [
        {
          text: "Mostrar aviso na tela e tocar som (recomendado)",
          value: "PREVIEW_E_SOM",
        },
        { text: "Mostrar somente o aviso na tela", value: "APENAS_PREVIEW" },
        { text: "Tocar somente o som", value: "APENAS_SOM" },
        { text: "Não avisar sobre novas mensagens", value: "NAO_NOTIFICAR" },
      ],
      popupTimeOptions: [
        { text: "3 segundos", value: 3000 },
        { text: "6 segundos", value: 6000 },
        { text: "10 segundos", value: 10000 },
        { text: "15 segundos", value: 15000 },
      ],
      notificationVolumeOptions: [
        { text: "30%", value: 30 },
        { text: "40%", value: 40 },
        { text: "50%", value: 50 },
        { text: "60%", value: 60 },
        { text: "70%", value: 70 },
        { text: "80% (padrão)", value: 80 },
        { text: "90%", value: 90 },
        { text: "100%", value: 100 },
      ],
      panel: [0, 1, 2, 3, 4, 5],
    };
  },

  created() {
    this.loadInitialChatData();
    this.connectWebSocket();
  },

  beforeDestroy() {
    clearTimeout(this.highlightTimer);
    clearTimeout(this.readDebounceTimer);
    this.clearSubscriptions();
    this.disconnectWebSocket();
    this.stopPingTimer();
    this.clearConfirmDelay();
  },

  computed: {
    notificationShowsScreenAlert() {
      return ["PREVIEW_E_SOM", "APENAS_PREVIEW"].includes(
        this.chatSettings.modoNotificacao,
      );
    },

    notificationPlaysSound() {
      return ["PREVIEW_E_SOM", "APENAS_SOM"].includes(
        this.chatSettings.modoNotificacao,
      );
    },

    shouldShowConnectionError() {
      return !this.isConnected && this.reconnectAttempts > 0;
    },

    reconnectStatusMessage() {
      if (this.isReconnectingNow) {
        return `Tentativas realizadas: ${this.reconnectAttempts}. Próxima tentativa: agora.`;
      }

      if (!this.nextReconnectAt) {
        return `Tentativas realizadas: ${this.reconnectAttempts}. Próxima tentativa: em instantes.`;
      }

      const secondsUntilRetry = Math.max(
        1,
        Math.ceil((this.nextReconnectAt - Date.now()) / 1000),
      );

      return `Tentativas realizadas: ${this.reconnectAttempts}. Próxima tentativa em ${secondsUntilRetry}s.`;
    },

    // Indica se está em viewport mobile (usando breakpoints do Vuetify)
    isMobile() {
      return this.$vuetify && this.$vuetify.breakpoint
        ? this.$vuetify.breakpoint.smAndDown
        : false;
    },

    isConversaSistema() {
      return this.selectedConversation?.tipo === "SISTEMA";
    },

    totalAnexoFilesSize() {
      return this.anexoFiles.reduce(
        (total, file) => total + (file?.size || 0),
        0,
      );
    },

    hasInvalidAnexoFiles() {
      return this.anexoFiles.some((file) => file.size > 10000000);
    },

    menuItems() {
      if (!this.selectedConversation) return [];
      if (this.isConversaSistema) return [];

      const items = [];

      if (this.selectedConversation.tipo === "GRUPO") {
        items.push({
          key: "dados-grupo",
          title: "Dados do Grupo",
          icon: "mdi-information-slab-circle-outline",
          color: "blue",
          action: this.abrirDialogGrupo,
        });
      }

      if (this.selectedConversation.tipo !== "SELF_CHAT") {
        items.push({
          key: "favorito",
          title: this.selectedConversation.favorito
            ? "Remover dos favoritos"
            : "Adicionar aos favoritos",
          icon: this.selectedConversation.favorito
            ? "mdi-star"
            : "mdi-star-outline",
          color: this.selectedConversation.favorito ? "amber" : "grey",
          action: this.toggleFavorito,
        });
      }

      // Arquivos compartilhados
      items.push({
        key: "arquivos",
        title: "Arquivos compartilhados",
        icon: "mdi-file-document-multiple-outline",
        color: "blue",
        action: this.abrirDialogListaArquivos,
      });

      if (this.selectedConversation.tipo === "GRUPO") {
        items.push({
          key: "sair-grupo",
          title: "Sair do grupo",
          icon: "mdi-exit-to-app",
          color: "red",
          action: this.confirmLeaveGroup,
        });
      }

      return items;
    },

    participantesOnline() {
      if (!this.selectedConversation?.participantes) return 0;

      return this.selectedConversation.participantes.filter(
        (p) => p.status === "ONLINE" || p.status === "OCUPADO",
      ).length;
    },
    filteredConversations() {
      if (!this.conversations) {
        return [];
      }

      const query = this.searchQuery.toLowerCase();
      return this.conversations.filter((conversation) =>
        conversation.nomeChat.toLowerCase().includes(query),
      );
    },
    groupedConversations() {
      if (!this.filteredConversations) {
        return {
          favoritos: [],
          chats: [],
          semMensagens: [],
        };
      }

      const favoritos = this.filteredConversations.filter(
        (conv) => conv.favorito,
      );

      const comMensagens = this.filteredConversations.filter(
        (conv) => !conv.favorito && conv.ultimaMensagem,
      );

      const semMensagens = this.filteredConversations.filter(
        (conv) => !conv.favorito && !conv.ultimaMensagem,
      );

      return {
        favoritos,
        chats: comMensagens,
        semMensagens,
      };
    },
    hasFavoritos() {
      return this.groupedConversations.favoritos.length > 0;
    },
    hasChats() {
      return this.groupedConversations.chats.length > 0;
    },
    hasSemMensagens() {
      return this.groupedConversations.semMensagens.length > 0;
    },

    isFormValid() {
      // Validação para a aba de grupo
      return (
        this.groupName.trim() !== "" && this.selectedParticipants.length > 0
      );
    },

    isStartConversationValid() {
      return !!this.selectedStartUserId && this.initialMessage.trim() !== "";
    },

    // Verifica se o usuário atual é proprietário do grupo
    isGroupOwner() {
      if (
        !this.selectedConversation ||
        !this.participants ||
        this.participants.length === 0
      ) {
        return false;
      }

      const currentUserParticipant = this.participants.find(
        (p) => p.idParticipante === this.currentUser.id,
      );
      if (currentUserParticipant.proprietario) {
        return true;
      }

      return false;
    },

    // Verifica se o usuário atual é administrador do grupo
    isGroupAdmin() {
      if (
        !this.selectedConversation ||
        !this.participants ||
        this.participants.length === 0
      ) {
        return false;
      }

      const currentUserParticipant = this.participants.find(
        (p) => p.idParticipante === this.currentUser.id,
      );

      if (currentUserParticipant.admin) {
        return true;
      }

      return false;
    },

    // Verifica se o usuário atual pode gerenciar membros (proprietário ou admin)
    canManageMembers() {
      return this.isGroupOwner || this.isGroupAdmin;
    },

    quantidadeSelecionadas() {
      return Object.keys(this.mensagensSelecionadas).length;
    },

    estiloCheckboxSelecao() {
      return {
        position: "absolute",
        left: "4px",
        top: "50%",
        transform: "translateY(-50%)",
        display: "inline-flex",
        cursor: "pointer",
      };
    },

    listUserComDepartamento() {
      return this.users.map((user) => {
        const departamento = user.departamento;

        return {
          ...user,
          nome: departamento ? `${user.nome} (${departamento})` : user.nome,
        };
      });
    },

    // Filtra usuários disponíveis para adicionar ao grupo (que não são participantes atuais)
    availableUsers() {
      if (!this.users || !this.participants) {
        return [];
      }

      const participantIds = this.participants.map((p) => p.idParticipante);
      return this.users.filter((user) => !participantIds.includes(user.id));
    },
  },

  methods: {
    async loadInitialChatData({ reloadCurrentConversation = false } = {}) {
      const currentConversationId =
        this.selectedConversation && this.selectedConversation.id;

      await Promise.all(
        [this.loadConversations(), this.consultarStatus(), this.loadChatSettings()].map(
          (task) => Promise.resolve(task).catch(() => null),
        ),
      );

      if (reloadCurrentConversation && currentConversationId) {
        await this.loadMessages(currentConversationId);
      }
    },

    // Formatação
    formatarStatus(status) {
      if (!status) return "";
      if (status === "NAO_PERTURBE") return "Não perturbe";
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },

    formatTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    truncate(text, length, preserveEnds = false) {
      if (!text) return "";

      if (text.length <= length) {
        return text;
      }

      // Corte no final (padrão)
      if (!preserveEnds) {
        return text.slice(0, length) + "...";
      }

      // Corte no meio (preserva início e fim)
      const ellipsis = "...";
      const available = length - ellipsis.length;

      const startLength = Math.ceil(available / 2);
      const endLength = Math.floor(available / 2);

      return (
        text.slice(0, startLength) +
        ellipsis +
        text.slice(text.length - endLength)
      );
    },
    // Formatar data/hora das mensagens (hora para hoje, data+hora para outros dias)
    formatMessageDateTime(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      const hoje = new Date();

      // Verificar se é o dia atual
      if (date.toDateString() === hoje.toDateString()) {
        // Mostrar apenas a hora para mensagens do dia atual
        return date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      } else {
        // Mostrar data + hora para mensagens de outros dias
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const hoje = new Date();
      const ontem = new Date(hoje);
      ontem.setDate(hoje.getDate() - 1);

      // Verificar se é hoje
      if (date.toDateString() === hoje.toDateString()) {
        return `Hoje às ${date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      }

      // Verificar se é ontem
      if (date.toDateString() === ontem.toDateString()) {
        return `Ontem às ${date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      }

      // Caso contrário, mostrar data completa
      return `${date.toLocaleDateString()} às ${date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    },

    getInitials(name) {
      if (!name) return "";
      return name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase()
        .substring(0, 2);
    },

    getAvatarColor(index) {
      const colors = [
        "avatar-indigo",
        "avatar-purple",
        "avatar-pink",
        "avatar-blue",
        "avatar-teal",
        "avatar-orange",
      ];
      return colors[index % colors.length];
    },

    getSendColor(userId) {
      const colors = [
        "#4caf50",
        "#2196f3",
        "#4caf50",
        "#2196f3",
        "#00897b",
        "#ff9800",
      ];

      return colors[userId % colors.length];
    },

    abrirDialogAnexo() {
      if (this.isConversaSistema) return;
      this.dialogAnexo = true;
      this.anexoFile = null;
      this.anexoFiles = [];
      this.enviandoArquivoIndex = 0;
    },

    handleAnexoFilesChange(files) {
      this.anexoFiles = Array.isArray(files) ? files : files ? [files] : [];
      this.anexoFile = this.anexoFiles[0] || null;

      if (this.hasInvalidAnexoFiles) {
        this.showSnackbar("Cada arquivo deve ter menos de 10MB", "warning");
      }
    },

    handleAddAnexoFiles(event) {
      const chave = (file) => `${file.name}-${file.size}-${file.lastModified}`;
      const existentes = new Set(this.anexoFiles.map(chave));
      const novos = Array.from(event.target.files || []).filter(
        (file) => !existentes.has(chave(file)),
      );
      event.target.value = "";
      this.handleAnexoFilesChange([...this.anexoFiles, ...novos]);
    },

    removerAnexoFile(file) {
      this.handleAnexoFilesChange(
        this.anexoFiles.filter((item) => item !== file),
      );
    },

    handlePasteImage(event) {
      if (this.isConversaSistema) {
        event.preventDefault();
        return;
      }

      const file = this.getPastedImageFile(event);
      if (!file) {
        return;
      }

      event.preventDefault();

      if (!this.selectedConversation) {
        this.showSnackbar("Selecione uma conversa para colar a imagem", "warning");
        return;
      }

      if (!this.isConnected) {
        this.showSnackbar("Conecte-se ao chat antes de enviar a imagem", "warning");
        return;
      }

      if (file.size > 10000000) {
        this.showSnackbar("A imagem deve ter menos de 10MB", "warning");
        return;
      }

      this.anexoFile = file;
      this.anexoFiles = [file];
      this.dialogAnexo = true;
    },

    getPastedImageFile(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData || !clipboardData.items) {
        return null;
      }

      const imageItem = Array.from(clipboardData.items).find(
        (item) => item.kind === "file" && item.type.startsWith("image/"),
      );

      if (!imageItem) {
        return null;
      }

      const blob = imageItem.getAsFile();
      if (!blob) {
        return null;
      }

      const extension = this.getImageExtension(blob.type);
      const fileName = `imagem-colada-${this.formatPastedImageTimestamp()}.${extension}`;

      return new File([blob], fileName, { type: blob.type });
    },

    getImageExtension(mimeType) {
      const extensions = {
        "image/png": "png",
        "image/jpeg": "jpg",
        "image/jpg": "jpg",
        "image/gif": "gif",
        "image/webp": "webp",
        "image/bmp": "bmp",
      };

      return extensions[mimeType] || "png";
    },

    formatPastedImageTimestamp() {
      const date = new Date();
      const pad = (value) => String(value).padStart(2, "0");

      return [
        date.getFullYear(),
        pad(date.getMonth() + 1),
        pad(date.getDate()),
        pad(date.getHours()),
        pad(date.getMinutes()),
        pad(date.getSeconds()),
      ].join("");
    },

    // Métodos para gravação de áudio
    abrirDialogAudio() {
      if (this.isConversaSistema) return;
      this.dialogAudio = true;
      this.resetarEstadoAudio();
    },

    fecharDialogAudio() {
      if (this.isRecording) {
        this.pararGravacao();
      }
      this.resetarEstadoAudio();
      this.dialogAudio = false;
    },

    resetarEstadoAudio() {
      if (this.audioURL) {
        URL.revokeObjectURL(this.audioURL);
      }
      if (this.audioTimer) {
        clearInterval(this.audioTimer);
      }
      this.audioRecorder = null;
      this.isRecording = false;
      this.audioBlob = null;
      this.audioURL = null;
      this.audioDuration = 0;
      this.audioTimer = null;
    },

    solicitarPermissaoMicrofone() {
      this.solicitandoPermissao = true;

      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          this.permissaoMicrofone = true;
          this.prepararGravador(stream);
        })
        .catch((error) => {
          console.error("Erro ao solicitar permissão de microfone:", error);
          this.permissaoMicrofone = false;
        })
        .finally(() => {
          this.solicitandoPermissao = false;
        });
    },

    prepararGravador(stream) {
      try {
        const options = { mimeType: "audio/webm" };
        this.audioRecorder = new MediaRecorder(stream, options);

        this.audioRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            const chunks = [];
            chunks.push(event.data);
            this.audioBlob = new Blob(chunks, { type: "audio/webm" });
            this.audioURL = URL.createObjectURL(this.audioBlob);
          }
        };

        this.audioRecorder.onstop = () => {
          stream.getTracks().forEach((track) => track.stop());
        };
      } catch (error) {
        console.error("Erro ao preparar gravador:", error);
      }
    },

    iniciarGravacao() {
      if (!this.audioRecorder) return;

      try {
        this.audioRecorder.start();
        this.isRecording = true;
        this.audioDuration = 0;

        this.audioTimer = setInterval(() => {
          this.audioDuration++;
          // limitado a 2min
          if (this.audioDuration >= 120) {
            this.pararGravacao();
          }
        }, 1000);
      } catch (error) {
        console.error("Erro ao iniciar gravação:", error);
      }
    },

    pararGravacao() {
      if (!this.audioRecorder || this.audioRecorder.state === "inactive")
        return;

      try {
        this.audioRecorder.stop();
        this.isRecording = false;

        if (this.audioTimer) {
          clearInterval(this.audioTimer);
        }
      } catch (error) {
        console.error("Erro ao parar gravação:", error);
      }
    },

    descartarAudio() {
      this.resetarEstadoAudio();
      this.solicitarPermissaoMicrofone();
    },

    formatAudioTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },

    enviarAudio() {
      if (this.isConversaSistema) {
        return;
      }

      if (!this.audioBlob || !this.selectedConversation) {
        return;
      }

      this.enviandoAudio = true;

      const fileName = "Audio " + this.formatAudioTime(this.audioDuration);

      const audioFile = new File([this.audioBlob], fileName, {
        type: "audio/webm",
      });

      batepapo
        .enviarArquivo(this.selectedConversation.id, audioFile)
        .then((response) => {
          this.fecharDialogAudio();

          this.showSnackbar("Áudio enviado com sucesso!", "success");
        })
        .catch((error) => {
          console.error("Erro ao enviar áudio:", error);
          this.showSnackbar("Erro ao enviar áudio. Tente novamente.", "error");
        })
        .finally(() => {
          this.enviandoAudio = false;
        });
    },

    async enviarArquivo() {
      if (this.isConversaSistema) {
        return;
      }

      if (!this.anexoFiles.length || !this.selectedConversation) {
        return;
      }

      if (this.hasInvalidAnexoFiles) {
        this.showSnackbar("Cada arquivo deve ter menos de 10MB", "warning");
        return;
      }

      this.enviandoArquivo = true;
      this.enviandoArquivoIndex = 0;

      let enviados = 0;
      const falhas = [];

      try {
        for (const [index, file] of this.anexoFiles.entries()) {
          this.enviandoArquivoIndex = index + 1;

          try {
            await batepapo.enviarArquivo(this.selectedConversation.id, file);
            enviados += 1;
          } catch (error) {
            console.error("Erro ao enviar arquivo:", error);
            const message =
              error.response && error.response.data
                ? error.response.data
                : "Erro ao enviar arquivo. Tente novamente.";
            falhas.push({
              nome: file.name,
              message,
            });
          }
        }

        if (falhas.length) {
          this.showSnackbar(
            `${enviados} arquivo(s) enviado(s), ${falhas.length} com erro.`,
            "warning",
          );
        } else {
          this.dialogAnexo = false;
          this.anexoFile = null;
          this.anexoFiles = [];
          this.showSnackbar(
            `${enviados} arquivo(s) enviado(s) com sucesso!`,
            "success",
          );
        }
      } finally {
        this.enviandoArquivo = false;
        this.enviandoArquivoIndex = 0;
      }
    },

    abrirDialogListaArquivos() {
      if (!this.selectedConversation) {
        return;
      }

      this.listaArquivos = [];
      this.dialogListaArquivos = true;

      // Carregar a lista de arquivos
      batepapo
        .listarArquivos(this.selectedConversation.id)
        .then((response) => {
          this.listaArquivos = response.data;
        })
        .catch((error) => {
          console.error("Erro ao carregar arquivos:", error);
          this.showSnackbar(
            "Erro ao carregar arquivos. Tente novamente.",
            "error",
          );
        });
    },

    getStatusParticipant(idParticipante) {
      if (
        !this.selectedConversation ||
        !this.selectedConversation.participantes
      ) {
        return "";
      }
      const participant = this.selectedConversation.participantes.find(
        (p) => p.userId === idParticipante,
      );
      return participant ? participant.status : "OFFLINE";
    },

    abrirDialogGrupo() {
      if (this.selectedConversation.tipo !== "GRUPO") return;
      this.groupNameEdit = this.selectedConversation.nomeChat;
      this.showManageMembersDialog = true;
    },

    // Voltar para a lista de conversas no mobile
    voltarParaLista() {
      this.selectedConversation = null;
      this.messages = [];
      this.replyingTo = null;
      this.cancelarSelecao();
    },

    fecharDialogGrupo() {
      this.showManageMembersDialog = false;
      this.groupNameEdit = "";
      this.selectedNewMembers = [];
    },
    // Carregar conversas
    async loadConversations() {
      try {
        this.loadingConversations = true;
        const response = await batepapo.listarConversas();
        this.conversations = response.data;
        this.loadingConversations = false;

        if (this.openPendingConversationFromNotification()) {
          return;
        }

        if (this.selectedConversation) {
          this.selectedConversation = this.conversations.find(
            (c) => c.id === this.selectedConversation.id,
          );
        }
      } catch (error) {
        console.error("Erro ao carregar conversas:", error);
        this.showSnackbar("Erro ao carregar conversas", "error");
        this.loadingConversations = false;
      }
    },

    openPendingConversationFromNotification() {
      const pendingConversationId = sessionStorage.getItem(
        "batepapo_open_conversation_id",
      );

      if (!pendingConversationId) {
        return false;
      }

      sessionStorage.removeItem("batepapo_open_conversation_id");

      const conversationId = Number(pendingConversationId);
      const conversation = this.conversations.find(
        (item) => item.id === conversationId,
      );

      if (!conversation) {
        return false;
      }

      this.selectConversation(conversation);
      return true;
    },

    filePreviewUrl(file) {
      return URL.createObjectURL(file);
    },

    isImage(file) {
      return file && file.type && file.type.startsWith("image/");
    },

    isPdf(file) {
      return file && file.type === "application/pdf";
    },

    // Métodos para manipulação de arquivos na lista
    getFileName(conteudo) {
      try {
        const fileData = JSON.parse(conteudo);
        return fileData.nomeOriginal || "Arquivo";
      } catch (e) {
        return "Arquivo";
      }
    },

    getFileUrl(fileId, action) {
      const base = "https://drive.usercontent.google.com";

      switch (action) {
        case "download":
          return `${base}/download?id=${fileId}`;
        case "preview":
          return `https://drive.google.com/file/d/${fileId}/preview`;
        case "view":
          return `https://drive.google.com/file/d/${fileId}/view`;
        default:
          return "#";
      }
    },

    getFileIcon(nomeArquivo) {
      try {
        const extension = nomeArquivo.split(".").pop().toLowerCase();
        switch (extension) {
          case "pdf":
            return "mdi-file-pdf-box";
          case "doc":
          case "docx":
            return "mdi-file-word";
          case "xls":
          case "xlsx":
          case "csv":
            return "mdi-file-excel";
          case "jpg":
          case "jpeg":
          case "png":
          case "gif":
          case "webp":
            return "mdi-file-image";
          case "txt":
            return "mdi-file-document-outline";
          default:
            return "mdi-file-outline";
        }
      } catch (e) {
        return "mdi-file-outline";
      }
    },

    getFileIconColor(message, fallback) {
      try {
        const extension = message.nomeArquivo.split(".").pop().toLowerCase();
        if (message.idRemetente === this.currentUser.id) {
          return fallback;
        }

        switch (extension) {
          case "pdf":
            return "red";
          case "doc":
          case "docx":
            return "blue";
          case "xls":
          case "xlsx":
          case "csv":
            return "green";
          case "jpg":
          case "jpeg":
          case "png":
          case "gif":
          case "webp":
            return "purple";
          case "txt":
            return "grey";
          default:
            return "grey";
        }
      } catch (e) {
        return "grey";
      }
    },

    // Verificar se o arquivo é uma imagem pelo nome
    isPreview(nomeArquivo) {
      if (!nomeArquivo) return false;

      try {
        const extension = nomeArquivo.split(".").pop().toLowerCase();
        return [
          "jpg",
          "jpeg",
          "png",
          "gif",
          "webp",
          "svg",
          "mp4",
          "pdf",
        ].includes(extension);
      } catch (e) {
        return false;
      }
    },

    // Verificar se o arquivo é um áudio
    isAudio(tipoArquivo) {
      if (!tipoArquivo) return false;

      if (tipoArquivo.includes("/")) {
        return tipoArquivo.startsWith("audio/");
      }

      const ext = tipoArquivo.toLowerCase();

      return ["mp3", "wav", "ogg", "m4a", "aac", "flac", "webm"].includes(ext);
    },

    // Selecionar conversa
    selectConversation(conversation) {
      this.processedMessageIds.clear();
      this.selectedConversation = conversation;
      this.messages = [];
      this.replyingTo = null;
      this.cancelarSelecao();
      this.highlightedMessageId = null;
      this.hasMoreMessages = true;
      this.loadingOlderMessages = false;
      this.isInitialLoad = true;
      this.novasMensagensNaoVistas = 0;

      this.loadMessages(conversation.id);

      // Verificar e tentar reconectar ao WebSocket se necessário
      if (!this.checkWebSocketConnection()) {
        this.showSnackbar(
          "Tentando reconectar ao servidor de chat...",
          "warning",
        );
      }
    },

    // Carregar mensagens
    async loadMessages(conversationId) {
      let shouldScrollToBottom = false;

      try {
        this.loadingMessages = true;
        const response = await batepapo.obterMensagens(conversationId, {
          limit: this.messagesPageSize,
        });

        if (
          !this.selectedConversation ||
          this.selectedConversation.id !== conversationId
        ) {
          return;
        }

        // Processar mensagens e adicionar separadores de data
        this.messages = this.normalizeMessageDateSeparators(response.data);
        this.hasMoreMessages =
          this.countChatMessages(response.data) >= this.messagesPageSize;
        shouldScrollToBottom = true;
      } catch (error) {
        console.error("Erro ao carregar mensagens:", error);
        this.showSnackbar("Erro ao carregar mensagens", "error");
      } finally {
        this.loadingMessages = false;

        if (shouldScrollToBottom) {
          this.scrollToBottomAfterRender(true);
          const ateMensagemId = this.getNewestLoadedMessageId();
          if (ateMensagemId) {
            this.$nextTick(() => {
              this.queueConversationRead(conversationId, ateMensagemId);
            });
          }
        } else {
          this.isInitialLoad = false;
        }
      }
    },

    handleMessagesScroll(event) {
      const container = event.target;
      this.atualizarPosicaoRolagem(container);

      if (
        !this.isInitialLoad &&
        container.scrollTop <= 80 &&
        this.hasMoreMessages &&
        !this.loadingMessages &&
        !this.loadingOlderMessages
      ) {
        this.loadOlderMessages();
      }
    },

    async loadOlderMessages() {
      if (!this.selectedConversation || !this.hasMoreMessages) {
        return;
      }

      const beforeId = this.getOldestLoadedMessageId();
      if (!beforeId) {
        this.hasMoreMessages = false;
        return;
      }

      const container = this.$refs.messagesContainer;
      const previousScrollHeight = container ? container.scrollHeight : 0;
      const previousScrollTop = container ? container.scrollTop : 0;

      try {
        this.loadingOlderMessages = true;

        const response = await batepapo.obterMensagens(
          this.selectedConversation.id,
          {
            beforeId,
            limit: this.messagesPageSize,
          },
        );

        const olderMessages = response.data || [];
        this.hasMoreMessages =
          this.countChatMessages(olderMessages) >= this.messagesPageSize;

        if (olderMessages.length === 0) {
          return;
        }

        this.messages = this.mergeMessagePages(olderMessages, this.messages);

        this.$nextTick(() => {
          const updatedContainer = this.$refs.messagesContainer;
          if (!updatedContainer) return;

          updatedContainer.scrollTop =
            updatedContainer.scrollHeight -
            previousScrollHeight +
            previousScrollTop;
        });
      } catch (error) {
        console.error("Erro ao carregar mensagens antigas:", error);
        this.showSnackbar("Erro ao carregar mensagens antigas", "error");
      } finally {
        this.loadingOlderMessages = false;
      }
    },

    getOldestLoadedMessageId() {
      const firstMessage = this.messages.find(
        (message) => !this.isDateSeparator(message),
      );

      return firstMessage ? firstMessage.id : null;
    },

    getNewestLoadedMessageId() {
      for (let index = this.messages.length - 1; index >= 0; index -= 1) {
        const message = this.messages[index];
        if (!this.isDateSeparator(message) && Number(message.id) > 0) {
          return Number(message.id);
        }
      }

      return null;
    },

    countChatMessages(messages) {
      return (messages || []).filter((message) => !this.isDateSeparator(message))
        .length;
    },

    mergeMessagePages(olderMessages, currentMessages) {
      return this.normalizeMessageDateSeparators([
        ...olderMessages,
        ...currentMessages,
      ]);
    },

    normalizeMessageDateSeparators(messages) {
      const normalized = [];
      let lastDateSeparatorDate = null;

      for (const message of messages || []) {
        if (this.isDateSeparator(message)) {
          if (
            lastDateSeparatorDate &&
            this.isSameMessageDay(lastDateSeparatorDate, message.dataEnvio)
          ) {
            continue;
          }

          normalized.push({
            ...message,
            id: `data-${this.getMessageDayKey(message.dataEnvio)}`,
          });
          lastDateSeparatorDate = message.dataEnvio;
          continue;
        }

        normalized.push(message);
      }

      return normalized;
    },

    isDateSeparator(message) {
      return message && message.tipo === "DATA";
    },

    isSameMessageDay(firstDate, secondDate) {
      if (!firstDate || !secondDate) return false;

      const first = new Date(firstDate);
      const second = new Date(secondDate);

      return first.toDateString() === second.toDateString();
    },

    getMessageDayKey(dateString) {
      if (!dateString) return "unknown";

      const date = new Date(dateString);
      const pad = (value) => String(value).padStart(2, "0");

      return [
        date.getFullYear(),
        pad(date.getMonth() + 1),
        pad(date.getDate()),
      ].join("-");
    },

    queueConversationRead(conversationId, ateMensagemId, delay = 150) {
      const normalizedConversationId = Number(conversationId);
      const normalizedMessageId = Number(ateMensagemId);

      if (
        !Number.isInteger(normalizedConversationId) ||
        normalizedConversationId <= 0 ||
        !Number.isInteger(normalizedMessageId) ||
        normalizedMessageId <= 0
      ) {
        return;
      }

      const lastConfirmed = Number(
        this.lastReadMessageByConversation[normalizedConversationId] || 0,
      );
      const activeMessageId =
        this.activeReadRequest &&
        this.activeReadRequest.conversationId === normalizedConversationId
          ? this.activeReadRequest.ateMensagemId
          : 0;
      const pendingMessageId = Number(
        this.pendingConversationReads[normalizedConversationId] || 0,
      );

      if (
        normalizedMessageId <=
        Math.max(lastConfirmed, activeMessageId, pendingMessageId)
      ) {
        return;
      }

      this.$set(
        this.pendingConversationReads,
        normalizedConversationId,
        normalizedMessageId,
      );

      clearTimeout(this.readDebounceTimer);
      this.readDebounceTimer = setTimeout(() => {
        this.readDebounceTimer = null;
        this.flushPendingConversationRead();
      }, delay);
    },

    async flushPendingConversationRead() {
      if (this.activeReadRequest) {
        return;
      }

      const conversationIdKey = Object.keys(
        this.pendingConversationReads,
      )[0];
      if (!conversationIdKey) {
        return;
      }

      const conversationId = Number(conversationIdKey);
      const ateMensagemId = Number(
        this.pendingConversationReads[conversationIdKey],
      );
      this.$delete(this.pendingConversationReads, conversationIdKey);
      this.activeReadRequest = { conversationId, ateMensagemId };

      try {
        const response = await batepapo.marcarConversaComoLida(
          conversationId,
          ateMensagemId,
        );
        this.$set(
          this.lastReadMessageByConversation,
          conversationId,
          Math.max(
            Number(this.lastReadMessageByConversation[conversationId] || 0),
            ateMensagemId,
          ),
        );
        this.handleConversationReadNotification(response.data);
      } catch (error) {
        console.error("Erro ao marcar conversa como lida:", error);
      } finally {
        this.activeReadRequest = null;

        if (Object.keys(this.pendingConversationReads).length > 0) {
          clearTimeout(this.readDebounceTimer);
          this.readDebounceTimer = setTimeout(() => {
            this.readDebounceTimer = null;
            this.flushPendingConversationRead();
          }, 0);
        }
      }
    },

    consultarStatus() {
      return batepapo.consultarStatus().then((response) => {
        this.userStatus = response.data.status;
      });
    },
    handleEnter(event) {
      if (this.isConversaSistema) {
        event.preventDefault();
        return;
      }

      // Shift + Enter → permite quebra de linha
      if (event.shiftKey) {
        return;
      }

      // Enter sozinho → envia
      event.preventDefault();
      this.sendMessage();
    },
    // Enviar mensagem
    async sendMessage() {
      if (this.isConversaSistema) return;
      if (!this.selectedConversation || !this.newMessage.trim()) return;

      try {
        const { enviada, restante, total, excedeu } = this.separarMensagemPorLimite(
          this.newMessage,
        );
        if (!enviada) return;
        const messageData = {
          idConversa: this.selectedConversation.id,
          idRemetente: this.currentUser.id,
          conteudo: enviada,
          tipo: "TEXTO",
        };

        // Verificar e tentar reconectar ao WebSocket se necessário
        if (!this.checkWebSocketConnection()) {
          this.showSnackbar(
            "Tentando reconectar ao servidor de chat antes de enviar a mensagem...",
            "warning",
          );

          // Aguardar um curto período para tentar a reconexão
          await new Promise((resolve) => setTimeout(resolve, 1000));

          if (!this.isConnected) {
            this.showSnackbar(
              "Não foi possível enviar a mensagem: WebSocket não conectado",
              "error",
            );
            return;
          }
        }

        const enviado = batepapo.sendMessageViaWebSocket(
          this.stompClient,
          this.selectedConversation.id,
          this.currentUser.id,
          messageData.conteudo,
          messageData.tipo,
          this.replyingTo ? this.replyingTo.id : null,
        );

        if (!enviado) {
          this.showSnackbar("Erro ao enviar mensagem", "error");
          return;
        }

        this.replyingTo = null;
        this.newMessage = restante;
        if (excedeu) {
          this.limiteMensagemTotal = total;
          this.dialogLimiteMensagem = true;
        }
        this.novasMensagensNaoVistas = 0;
        this.scrollToBottomAfterRender();
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.showSnackbar("Erro ao enviar mensagem", "error");
      }
    },

    // WebSocket
    connectWebSocket() {
      this.websocketManuallyClosed = false;
      this.reconnectAttempts = 0;
      this.lastConnectionError = "";
      this.tryConnectWebSocket();
    },

    // Verificar status da conexão WebSocket e reconectar se necessário
    checkWebSocketConnection() {
      if (!this.isConnected || !this.stompClient) {
        console.warn("WebSocket não conectado, tentando reconectar...");
        if (!this.reconnectTimer && !this.isReconnectingNow) {
          this.tryConnectWebSocket();
        }
      }

      return this.isConnected;
    },

    // Iniciar o timer para enviar ping a cada minuto
    startPingTimer() {
      this.stopPingTimer();
      batepapo.sendPing(this.stompClient);
      this.pingInterval = setInterval(() => {
        if (this.isConnected && this.stompClient) {
          batepapo.sendPing(this.stompClient);
        }
      }, 300000); // 5 minutos
    },

    // Parar o timer de ping
    stopPingTimer() {
      if (this.pingInterval) {
        clearInterval(this.pingInterval);
        this.pingInterval = null;
      }
    },

    getReconnectDelay() {
      return this.reconnectAttempts <= this.fastReconnectAttempts
        ? this.fastReconnectInterval
        : this.fallbackReconnectInterval;
    },

    scheduleWebSocketReconnect() {
      if (this.websocketManuallyClosed) return;

      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }

      const delay = this.getReconnectDelay();
      this.nextReconnectAt = Date.now() + delay;

      this.reconnectTimer = setTimeout(() => {
        this.reconnectTimer = null;
        this.tryConnectWebSocket();
      }, delay);
    },

    retryWebSocketNow() {
      if (this.isReconnectingNow) return;

      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }

      this.nextReconnectAt = null;
      this.tryConnectWebSocket();
    },

    // Tentar conectar ao WebSocket com retentativas
    tryConnectWebSocket() {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }

      this.isReconnectingNow = true;
      this.nextReconnectAt = null;
      const connectionId = ++this.websocketConnectionId;

      this.stompClient = batepapo.connectWebSocket({
        onConnect: (frame, client) => {
          if (connectionId !== this.websocketConnectionId) return;

          const shouldReloadInitialData = this.reconnectAttempts > 0;

          this.isConnected = true;
          this.isReconnectingNow = false;
          this.stompClient = client;
          this.reconnectAttempts = 0;
          this.lastConnectionError = "";
          this.nextReconnectAt = null;

          this.subscribeToUser();

          // Iniciar o timer de ping quando conectar
          this.startPingTimer();

          if (shouldReloadInitialData) {
            this.loadInitialChatData({ reloadCurrentConversation: true });
          }
        },
        onError: (error) => {
          if (connectionId !== this.websocketConnectionId) return;

          this.isConnected = false;
          this.isReconnectingNow = false;
          this.stopPingTimer();
          this.clearSubscriptions();
          this.lastConnectionError =
            (error && (error.message || error.toString())) ||
            "Erro ao conectar no WebSocket";
          this.reconnectAttempts++;

          const delay = this.getReconnectDelay();
          const retryMessage =
            this.reconnectAttempts <= this.fastReconnectAttempts
              ? `Tentando reconectar em ${delay / 1000} segundos... (${
                  this.reconnectAttempts
                }/${this.fastReconnectAttempts})`
              : "Conexão indisponível. Tentando reconectar a cada 1 minuto.";

          // this.showSnackbar(retryMessage, "warning");
          this.scheduleWebSocketReconnect();
        },
      });
    },

    disconnectWebSocket() {
      this.websocketManuallyClosed = true;
      this.websocketConnectionId++;
      this.clearSubscriptions();

      // Parar o timer de ping quando desconectar
      this.stopPingTimer();

      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }

      this.reconnectAttempts = 0;
      this.isReconnectingNow = false;
      this.nextReconnectAt = null;

      if (batepapo.disconnectWebSocket(this.stompClient)) {
        this.isConnected = false;
      }
    },

    // Método para limpar subscrições ativas
    clearSubscriptions() {
      if (
        this.currentSubscription &&
        this.currentSubscription.messageSubscription
      ) {
        this.currentSubscription.messageSubscription.unsubscribe();
      }

      if (
        this.currentSubscription &&
        this.currentSubscription.readSubscription
      ) {
        this.currentSubscription.readSubscription.unsubscribe();
      }

      if (
        this.currentSubscription &&
        this.currentSubscription.statusSubscription
      ) {
        this.currentSubscription.statusSubscription.unsubscribe();
      }

      this.currentSubscription = null;
    },

    upsertConversation(conversation) {
      if (!conversation || !conversation.id) return;

      const index = this.conversations.findIndex(
        (item) => item.id === conversation.id,
      );

      if (index === -1) {
        this.conversations.unshift(conversation);
      } else {
        this.$set(this.conversations, index, {
          ...this.conversations[index],
          ...conversation,
        });
      }

      if (
        this.selectedConversation &&
        this.selectedConversation.id === conversation.id
      ) {
        this.selectedConversation = {
          ...this.selectedConversation,
          ...conversation,
        };
      }
    },

    subscribeToUser() {
      if (!this.isConnected || !this.stompClient) return;

      this.clearSubscriptions();

      this.currentSubscription = batepapo.subscribeToUser(
        this.stompClient,
        // Callback para mensagens recebidas
        (receivedMessage) => {
          if (!receivedMessage.idConversa) {
            this.upsertConversation(receivedMessage);
            return;
          }

          if (receivedMessage.excluida) {
            if (
              this.selectedConversation &&
              this.selectedConversation.id === receivedMessage.idConversa
            ) {
              this.aplicarExclusaoLocal(receivedMessage);
            }
            this.loadConversations();
            return;
          }

          this.processedMessageIds.add(receivedMessage.id);

          // Limitar o tamanho do conjunto para evitar crescimento infinito
          if (this.processedMessageIds.size > 100) {
            const iterator = this.processedMessageIds.values();
            this.processedMessageIds.delete(iterator.next().value);
          }

          // Tocar som de alerta para novas mensagens que não são do usuário atual
          if (receivedMessage.idRemetente !== this.currentUser.id) {
            this.playAlertSound();
          }

          // Adicionar mensagem à lista se for da conversa atual
          if (
            this.selectedConversation &&
            this.selectedConversation.id === receivedMessage.idConversa
          ) {
            const noRodapeAntesDaMensagem = this.estaNoRodapeDaConversa();
            this.messages.push(receivedMessage);

            const mensagemPropria =
              receivedMessage.idRemetente === this.currentUser.id;

            if (mensagemPropria || noRodapeAntesDaMensagem) {
              this.novasMensagensNaoVistas = 0;
              this.scrollToBottomAfterRender();
              if (!mensagemPropria) {
                this.queueConversationRead(
                  receivedMessage.idConversa,
                  receivedMessage.id,
                );
              }
            } else {
              this.novasMensagensNaoVistas += 1;
            }
          }
          this.loadConversations();
        },
        // Callback para notificações de leitura
        (readNotification) => {
          if (readNotification.tipoEvento === "CONVERSA_LIDA") {
            this.handleConversationReadNotification(readNotification);
          }
        },
        // Callback específico para notificações de status/presença
        (statusNotification) => {
          this.loadConversations();
          this.consultarStatus();

          if (this.selectedConversation) {
            batepapo
              .obterConversa(this.selectedConversation.id)
              .then((response) => {
                this.selectedConversation = response.data;
              })
              .catch((error) => {
                console.error("Erro ao atualizar dados da conversa:", error);
              });
          }
        },
      );
    },

    handleConversationReadNotification(readNotification) {
      const conversationId = Number(
        readNotification && readNotification.idConversa,
      );
      const readerId = Number(
        readNotification && readNotification.idUsuarioLeitor,
      );
      const ateMensagemId = Number(
        readNotification && readNotification.ateMensagemId,
      );

      if (
        !Number.isInteger(conversationId) ||
        conversationId <= 0 ||
        !Number.isInteger(readerId) ||
        readerId <= 0 ||
        !Number.isInteger(ateMensagemId) ||
        ateMensagemId <= 0
      ) {
        return;
      }

      const isCurrentReader = readerId === Number(this.currentUser.id);
      const conversationIndex = this.conversations.findIndex(
        (conversation) => Number(conversation.id) === conversationId,
      );
      const listedConversation =
        conversationIndex !== -1
          ? this.conversations[conversationIndex]
          : null;
      const isSelectedConversation =
        this.selectedConversation &&
        Number(this.selectedConversation.id) === conversationId;
      const conversation = isSelectedConversation
        ? this.selectedConversation
        : listedConversation;

      if (isCurrentReader) {
        this.$set(
          this.lastReadMessageByConversation,
          conversationId,
          Math.max(
            Number(this.lastReadMessageByConversation[conversationId] || 0),
            ateMensagemId,
          ),
        );
      }

      if (listedConversation) {
        if (isCurrentReader) {
          this.$set(this.conversations, conversationIndex, {
            ...listedConversation,
            mensagensNaoLidas: 0,
          });
        }

        this.applyReadNotificationToMessage(
          listedConversation.ultimaMensagem,
          readNotification,
          listedConversation,
        );
      }

      if (isSelectedConversation) {
        if (isCurrentReader) {
          this.selectedConversation.mensagensNaoLidas = 0;
        }

        this.applyReadNotificationToMessage(
          this.selectedConversation.ultimaMensagem,
          readNotification,
          this.selectedConversation,
        );

        for (const message of this.messages) {
          this.applyReadNotificationToMessage(
            message,
            readNotification,
            conversation,
          );
        }

        this.applyReadNotificationToMessage(
          this.activeMessage,
          readNotification,
          conversation,
        );
      }
    },

    applyReadNotificationToMessage(message, readNotification, conversation) {
      if (!message || this.isDateSeparator(message) || message.excluida) {
        return;
      }

      const messageId = Number(message.id);
      const readerId = Number(readNotification.idUsuarioLeitor);
      const ateMensagemId = Number(readNotification.ateMensagemId);

      if (
        !Number.isInteger(messageId) ||
        messageId <= 0 ||
        messageId > ateMensagemId ||
        Number(message.idRemetente) === readerId
      ) {
        return;
      }

      const existingReads = Array.isArray(message.leitoPor)
        ? message.leitoPor
        : [];

      if (
        !existingReads.some(
          (readReceipt) => Number(readReceipt.idUsuario) === readerId,
        )
      ) {
        const participant =
          conversation && Array.isArray(conversation.participantes)
            ? conversation.participantes.find(
                (item) => Number(item.userId) === readerId,
              )
            : null;

        this.$set(message, "leitoPor", [
          ...existingReads,
          {
            id: null,
            idUsuario: readerId,
            idMensagem: messageId,
            nomeUsuario: participant ? participant.nome : null,
            dataLeitura: readNotification.dataLeitura,
          },
        ]);
      }

      const participantIds =
        conversation && Array.isArray(conversation.participantes)
          ? conversation.participantes.map((item) => Number(item.userId))
          : [];
      const requiredReaderIds = participantIds.filter(
        (participantId) => participantId !== Number(message.idRemetente),
      );
      const readReceiptIds = new Set(
        (message.leitoPor || []).map((readReceipt) =>
          Number(readReceipt.idUsuario),
        ),
      );
      const readByAll =
        requiredReaderIds.length > 0 &&
        requiredReaderIds.every((participantId) =>
          readReceiptIds.has(participantId),
        );

      if (readByAll) {
        message.lida = true;
        message.status = "LIDA";
      } else if (!message.lida && readReceiptIds.size > 0) {
        message.status = "PARCIAL";
      }
    },

    atualizarPosicaoRolagem(container) {
      if (!container) return;
      if (this.estaNoRodapeDaConversa(container)) {
        this.novasMensagensNaoVistas = 0;
        const ateMensagemId = this.getNewestLoadedMessageId();
        if (this.selectedConversation && ateMensagemId) {
          this.queueConversationRead(
            this.selectedConversation.id,
            ateMensagemId,
          );
        }
      }
    },

    estaNoRodapeDaConversa(container = this.$refs.messagesContainer) {
      if (!container) return true;
      const distancia =
        container.scrollHeight - container.scrollTop - container.clientHeight;
      return distancia < 80;
    },

    irParaNovasMensagens() {
      this.novasMensagensNaoVistas = 0;
      this.scrollToBottomAfterRender();
      const ateMensagemId = this.getNewestLoadedMessageId();
      if (this.selectedConversation && ateMensagemId) {
        this.queueConversationRead(
          this.selectedConversation.id,
          ateMensagemId,
          0,
        );
      }
    },

    // Rolar para o final da conversa com estratégia multifásica (evita parar no meio em textos longos)
    scrollToBottomAfterRender(isInitial = false) {
      const scrollAction = () => {
        this.scrollToBottom();
      };

      this.$nextTick(() => {
        scrollAction();

        if (typeof window !== "undefined" && window.requestAnimationFrame) {
          window.requestAnimationFrame(() => {
            scrollAction();
            window.requestAnimationFrame(scrollAction);
          });
        }

        setTimeout(scrollAction, 50);
        setTimeout(scrollAction, 150);
        setTimeout(scrollAction, 300);
        setTimeout(() => {
          scrollAction();
          if (isInitial) {
            this.isInitialLoad = false;
          }
        }, 500);
      });
    },

    scrollToBottom() {
      if (this.$refs.messagesContainer) {
        this.$refs.messagesContainer.scrollTop =
          this.$refs.messagesContainer.scrollHeight;
      }
    },

    // Carregar usuários para nova conversa
    openStartConversationDialog() {
      this.selectedStartUserId = null;
      this.initialMessage = "";
      this.showStartConversationDialog = true;
    },

    closeStartConversationDialog() {
      this.showStartConversationDialog = false;
      this.selectedStartUserId = null;
      this.initialMessage = "";
    },

    openNewGroupDialog() {
      this.groupName = "";
      this.selectedParticipants = [];
      this.showNewConversationDialog = true;
    },

    async loadUsers() {
      try {
        this.loadingUsers = true;
        const response = await user.list_simples();
        this.users = response.data.filter(
          (user) => user.id !== this.currentUser.id,
        );
        this.loadingUsers = false;
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
        this.showSnackbar("Erro ao carregar usuários", "error");
        this.loadingUsers = false;
      }
    },

    // Criar nova conversa
    async startPrivateConversation() {
      if (!this.isStartConversationValid || this.startingConversation) return;

      try {
        this.startingConversation = true;
        const { enviada, restante, total, excedeu } = this.separarMensagemPorLimite(
          this.initialMessage,
        );
        if (!enviada) return;
        const response = await batepapo.iniciarConversaPrivada(
          this.selectedStartUserId,
          enviada,
        );

        await this.loadConversations();
        const conversation =
          this.conversations.find((c) => c.id === response.data.id) ||
          response.data;

        this.closeStartConversationDialog();
        this.selectConversation(conversation);
        this.newMessage = restante;
        if (excedeu) {
          this.limiteMensagemTotal = total;
          this.dialogLimiteMensagem = true;
        }
        this.showSnackbar("Conversa iniciada com sucesso", "success");
      } catch (error) {
        console.error("Erro ao iniciar conversa:", error);
        const message =
          error.response && error.response.data
            ? error.response.data
            : "Erro ao iniciar conversa";
        this.showSnackbar(message, "error");
      } finally {
        this.startingConversation = false;
      }
    },

    async createNewConversation() {
      try {
        this.creatingConversation = true;
        let response;

        // Criar grupo
        if (this.conversationTab === 0) {
          if (
            !this.groupName.trim() ||
            this.selectedParticipants.length === 0
          ) {
            this.showSnackbar(
              "Preencha todos os campos obrigatórios",
              "warning",
            );
            this.creatingConversation = false;
            return;
          }

          response = await batepapo.criarConversaGrupo(
            this.groupName.trim(),
            this.selectedParticipants,
          );
        }

        // Adicionar nova conversa à lista
        this.loadConversations();

        // Selecionar a nova conversa
        this.selectConversation(response.data);

        // Fechar diálogo e limpar campos
        this.showNewConversationDialog = false;
        this.selectedUserId = null;
        this.selectedParticipants = [];
        this.groupName = "";
        this.creatingConversation = false;

        this.showSnackbar("Conversa criada com sucesso", "success");
      } catch (error) {
        console.error("Erro ao criar conversa:", error);
        this.showSnackbar("Erro ao criar conversa", "error");
        this.creatingConversation = false;
      }
    },

    // Obter nome do remetente da última mensagem
    getNomeRemetente(mensagem) {
      if (!mensagem) return null;

      if (mensagem.nomeRemetente) {
        return mensagem.nomeRemetente + ":";
      }

      if (mensagem.tipo === "SISTEMA") {
        return null;
      }

      return "Usuário";
    },

    // Mostrar diálogo com usuários que leram a mensagem
    showReadByMenu(message) {
      // Só mostrar o menu se a mensagem for do usuário atual
      if (message.idRemetente === this.currentUser.id) {
        this.activeMessage = message;
        this.activeReadByMenu = true;
      }
    },
    // Obter referência do textarea
    getTextarea() {
      return document.getElementById("textareaRef");
    },
    // Formatar texto (negrito, itálico, sublinhado)
    formatar(tipo) {
      const textField = this.getTextarea();
      if (!textField) return;

      const start = textField.selectionStart;
      const end = textField.selectionEnd;
      const selectedText = this.newMessage.substring(start, end);

      let formattedText = "";
      let cursorPosition = start;

      switch (tipo) {
        case "bold":
          formattedText = `**${selectedText}**`;
          cursorPosition = start + 2;
          break;
        case "italic":
          formattedText = `_${selectedText}_`;
          cursorPosition = start + 1;
          break;
        case "underline":
          formattedText = `__${selectedText}__`;
          cursorPosition = start + 2;
          break;
      }

      // Se não houver texto selecionado, apenas inserir os marcadores e posicionar o cursor entre eles
      if (start === end) {
        this.newMessage =
          this.newMessage.substring(0, start) +
          formattedText +
          this.newMessage.substring(end);
        textField.focus();
        setTimeout(() => {
          textField.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
      } else {
        // Se houver texto selecionado, substituir pelo texto formatado
        this.newMessage =
          this.newMessage.substring(0, start) +
          formattedText +
          this.newMessage.substring(end);
        textField.focus();
      }
    },

    // Inserir emoji na mensagem
    onEmojiClick(event) {
      // Insere o emoji na posição atual do cursor ou no final do texto
      const emoji = event.detail.unicode;
      this.newMessage += emoji;

      // Fecha o emoji picker após selecionar um emoji
      this.showEmojiPicker = false;
    },

    // Formatar o conteúdo da mensagem para exibição
    formatarMensagem(conteudo) {
      if (!conteudo) return "";

      // Escape HTML para prevenir XSS
      let texto = this.escapeHtml(conteudo);

      // Aplicar formatação de negrito: **texto** -> <strong>texto</strong>
      texto = texto.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

      // Aplicar formatação de itálico: _texto_ -> <em>texto</em>
      texto = texto.replace(/_(.*?)_/g, "<em>$1</em>");

      // Aplicar formatação de sublinhado: __texto__ -> <u>texto</u>
      texto = texto.replace(/__(.*?)__/g, "<u>$1</u>");

      // Converter quebras de linha em <br>
      texto = texto.replace(/\n/g, "<br>");

      return texto;
    },

    textoPuroMensagem(mensagem) {
      if (!mensagem) return "";
      if (mensagem.tipo === "ARQUIVO") return mensagem.nomeArquivo || "";
      return String(mensagem.conteudo || "")
        .replace(/\*\*(.*?)\*\*/g, "$1")
        .replace(/__(.*?)__/g, "$1")
        .replace(/_(.*?)_/g, "$1");
    },

    nomeAutorResposta(ref) {
      if (!ref) return "";
      if (this.currentUser && ref.idRemetente === this.currentUser.id) return "Você";
      return ref.nomeRemetente || "Usuário";
    },

    textoPreviewResposta(ref) {
      const texto = this.textoPuroMensagem(ref).replace(/\s+/g, " ").trim();
      return texto.length > 120 ? `${texto.slice(0, 120)}…` : texto;
    },

    estiloBotaoAcoes(message) {
      const propria = this.currentUser && message.idRemetente === this.currentUser.id;
      return {
        position: "absolute",
        top: "8px",
        right: "8px",
        left: "auto",
        width: "26px",
        height: "26px",
        padding: 0,
        margin: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        cursor: "pointer",
        zIndex: 2,
        background: propria ? "rgba(255, 255, 255, 0.18)" : "rgba(100, 116, 139, 0.55)",
      };
    },

    podeSelecionarMensagem(message) {
      return (
        !!message &&
        message.id > 0 &&
        !message.excluida &&
        (message.tipo === "TEXTO" || message.tipo === "ARQUIVO")
      );
    },

    podeExcluirMensagem(message) {
      return (
        !this.isConversaSistema &&
        this.ehMensagemPropria(message) &&
        this.podeSelecionarMensagem(message)
      );
    },

    confirmarExclusaoMensagem(message) {
      if (!this.podeExcluirMensagem(message)) return;
      this.confirmDialog = {
        show: true,
        title: "Excluir mensagem",
        message: "Tem certeza que deseja excluir esta mensagem?",
        confirmText: "Excluir",
        color: "error",
        loading: false,
        confirmDelayRemaining: 0,
        closesGroup: false,
        action: () => this.excluirMensagem(message),
      };
    },

    async excluirMensagem(message) {
      try {
        this.confirmDialog.loading = true;
        const response = await batepapo.excluirMensagem(message.id);
        this.aplicarExclusaoLocal(response.data);
        this.closeConfirmDialog();
        this.loadConversations();
      } catch (error) {
        console.error("Erro ao excluir mensagem:", error);
        this.confirmDialog.loading = false;
        const detalhe = error && error.response && typeof error.response.data === "string"
          ? error.response.data
          : "Erro ao excluir mensagem";
        this.showSnackbar(detalhe, "error");
      }
    },

    aplicarExclusaoLocal(mensagemExcluida) {
      if (!mensagemExcluida || !mensagemExcluida.id) return;
      const id = mensagemExcluida.id;

      this.messages.forEach((m, index) => {
        if (m.id === id) {
          this.$set(this.messages, index, { ...m, ...mensagemExcluida });
        } else if (m.replyTo && m.replyTo.id === id && !m.replyTo.removida) {
          this.$set(this.messages, index, {
            ...m,
            replyTo: { id, removida: true, conteudo: "Mensagem removida" },
          });
        }
      });

      if (this.replyingTo && this.replyingTo.id === id) {
        this.replyingTo = null;
      }
      if (this.mensagensSelecionadas[id]) {
        this.$delete(this.mensagensSelecionadas, id);
      }
      if (this.highlightedMessageId === id) {
        this.highlightedMessageId = null;
      }
    },

    corMensagemApagada(message) {
      return this.ehMensagemPropria(message) ? "rgba(255, 255, 255, 0.75)" : "#94a3b8";
    },

    estiloMensagemApagada(message) {
      return {
        display: "flex",
        alignItems: "center",
        fontStyle: "italic",
        color: this.corMensagemApagada(message),
      };
    },

    estaSelecionada(message) {
      return !!this.mensagensSelecionadas[message.id];
    },

    estiloLinhaSelecao(message) {
      if (!this.modoSelecao) return null;
      const selecionada = this.estaSelecionada(message);
      return {
        position: "relative",
        paddingLeft: "40px",
        cursor: this.podeSelecionarMensagem(message) ? "pointer" : "default",
        background: selecionada ? "rgba(76, 175, 80, 0.10)" : null,
        borderRadius: "8px",
      };
    },

    iniciarSelecao(message) {
      this.replyingTo = null;
      this.mensagensSelecionadas = {};
      this.modoSelecao = true;
      if (this.podeSelecionarMensagem(message)) {
        this.$set(this.mensagensSelecionadas, message.id, true);
      }
    },

    alternarSelecao(message) {
      if (!this.podeSelecionarMensagem(message)) return;
      if (this.mensagensSelecionadas[message.id]) {
        this.$delete(this.mensagensSelecionadas, message.id);
      } else {
        this.$set(this.mensagensSelecionadas, message.id, true);
      }
    },

    cancelarSelecao() {
      this.modoSelecao = false;
      this.mensagensSelecionadas = {};
    },

    encaminharMensagemUnica(message) {
      if (!this.podeSelecionarMensagem(message)) return;
      this.idsParaEncaminhar = [message.id];
      this.destinatariosEncaminhar = [];
      this.showEncaminharDialog = true;
    },

    abrirDialogEncaminhar() {
      // Ordem cronológica da conversa de origem, não a ordem de clique
      this.idsParaEncaminhar = this.messages
        .filter((m) => this.mensagensSelecionadas[m.id])
        .map((m) => m.id);
      if (this.idsParaEncaminhar.length === 0) return;
      this.destinatariosEncaminhar = [];
      this.showEncaminharDialog = true;
    },

    fecharDialogEncaminhar() {
      this.showEncaminharDialog = false;
      this.destinatariosEncaminhar = [];
      this.idsParaEncaminhar = [];
    },

    async confirmarEncaminhamento() {
      if (this.encaminhando || this.destinatariosEncaminhar.length === 0) return;
      try {
        this.encaminhando = true;
        const response = await batepapo.encaminharMensagens(
          this.idsParaEncaminhar,
          this.destinatariosEncaminhar,
        );
        const totalDestinos = (response.data || []).length || this.destinatariosEncaminhar.length;
        this.showSnackbar(
          totalDestinos === 1
            ? "Mensagem encaminhada"
            : `Encaminhado para ${totalDestinos} conversas`,
          "success",
        );
        this.fecharDialogEncaminhar();
        this.cancelarSelecao();
      } catch (error) {
        console.error("Erro ao encaminhar mensagens:", error);
        const detalhe = error && error.response && typeof error.response.data === "string"
          ? error.response.data
          : "Erro ao encaminhar mensagens";
        this.showSnackbar(detalhe, "error");
      } finally {
        this.encaminhando = false;
      }
    },

    estiloCabecalhoEncaminhada(message) {
      const propria = this.ehMensagemPropria(message);
      return {
        display: "flex",
        alignItems: "center",
        minWidth: 0,
        maxWidth: "100%",
        margin: "0 0 8px",
        paddingBottom: "6px",
        borderBottom: propria
          ? "1px solid rgba(255, 255, 255, 0.35)"
          : "1px solid rgba(15, 23, 42, 0.10)",
        fontSize: "12px",
        lineHeight: "16px",
        color: propria ? "rgba(255, 255, 255, 0.95)" : "#475569",
      };
    },

    autorEncaminhada(message) {
      if (
        this.currentUser &&
        message.encaminhadaDeIdUsuario != null &&
        message.encaminhadaDeIdUsuario === this.currentUser.id
      ) {
        return "você";
      }
      return message.encaminhadaDeAutor || "Usuário";
    },

    formatarDataEncaminhada(data) {
      if (!data) return "";
      const d = Array.isArray(data)
        ? new Date(data[0], (data[1] || 1) - 1, data[2] || 1, data[3] || 0, data[4] || 0, data[5] || 0)
        : new Date(data);
      if (Number.isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    ehMensagemPropria(message) {
      return !!(this.currentUser && message && message.idRemetente === this.currentUser.id);
    },

    estiloCitacao(message) {
      const propria = this.ehMensagemPropria(message);
      const removida = message.replyTo && message.replyTo.removida;
      const corBarra = removida
        ? "#94a3b8"
        : propria
          ? "#ffffff"
          : this.getSendColor(message.replyTo.idRemetente);
      return {
        display: "block",
        boxSizing: "border-box",
        maxWidth: "100%",
        margin: "2px 0 10px",
        padding: "6px 10px 6px 10px",
        borderLeft: `4px solid ${corBarra}`,
        borderRadius: "6px",
        background: propria ? "rgba(0, 0, 0, 0.14)" : "rgba(15, 23, 42, 0.06)",
        cursor: removida ? "default" : "pointer",
        overflow: "hidden",
      };
    },

    estiloCitacaoAutor(message) {
      return {
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "16px",
        marginBottom: "2px",
        color: this.ehMensagemPropria(message)
          ? "#ffffff"
          : this.getSendColor(message.replyTo.idRemetente),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      };
    },

    corCitacaoTexto(message) {
      return this.ehMensagemPropria(message) ? "rgba(255, 255, 255, 0.88)" : "#475569";
    },

    estiloCitacaoTexto(message, removida = false) {
      return {
        fontSize: "12.5px",
        lineHeight: "17px",
        color: this.corCitacaoTexto(message),
        fontStyle: removida ? "italic" : "normal",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      };
    },

    iniciarResposta(message) {
      if (!message || message.id == null || message.id <= 0 || message.excluida) return;
      this.replyingTo = {
        id: message.id,
        idRemetente: message.idRemetente,
        nomeRemetente: message.nomeRemetente,
        conteudo: message.conteudo,
        tipo: message.tipo,
        nomeArquivo: message.nomeArquivo,
      };
      this.$nextTick(() => {
        const textarea = document.getElementById("textareaRef");
        if (textarea) textarea.focus();
      });
    },

    cancelarResposta() {
      this.replyingTo = null;
    },

    async copiarMensagem(message) {
      const texto = this.textoPuroMensagem(message);
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(texto);
        } else {
          const area = document.createElement("textarea");
          area.value = texto;
          area.setAttribute("readonly", "");
          area.style.position = "fixed";
          area.style.opacity = "0";
          document.body.appendChild(area);
          area.select();
          document.execCommand("copy");
          document.body.removeChild(area);
        }
        this.showSnackbar("Mensagem copiada", "success");
      } catch (error) {
        console.error("Erro ao copiar mensagem:", error);
        this.showSnackbar("Não foi possível copiar a mensagem", "error");
      }
    },

    async irParaMensagemCitada(replyTo) {
      if (!replyTo || replyTo.removida || !replyTo.id) return;

      const localizar = () => {
        const container = this.$refs.messagesContainer;
        return container
          ? container.querySelector(`[data-message-id="${replyTo.id}"]`)
          : null;
      };

      let alvo = localizar();
      for (let tentativa = 0; !alvo && this.hasMoreMessages && tentativa < 10; tentativa++) {
        await this.loadOlderMessages();
        await this.$nextTick();
        alvo = localizar();
      }

      if (!alvo) {
        this.showSnackbar("Mensagem original não encontrada", "warning");
        return;
      }

      alvo.scrollIntoView({ behavior: "smooth", block: "center" });
      this.highlightedMessageId = replyTo.id;
      clearTimeout(this.highlightTimer);
      this.highlightTimer = setTimeout(() => {
        this.highlightedMessageId = null;
      }, 1800);
    },

    // Formatar mensagem para preview (uma única linha sem quebras)
    formatarMensagemPreview(mensagem) {
      if (mensagem.excluida) {
        return `<i class="v-icon mdi mdi-cancel" style="font-size: 14px; vertical-align: middle; margin-right: 4px;"></i> <em>Mensagem apagada</em>`;
      }

      // Se for uma mensagem de arquivo
      if (mensagem.tipo === "ARQUIVO" && mensagem.nomeArquivo) {
        let icone = "mdi-file-outline";

        if (this.isAudio(mensagem.tipoArquivo)) {
          icone = "mdi-microphone";
          return `<i class="v-icon mdi ${icone}" style="font-size: 14px; vertical-align: middle; margin-right: 4px;"></i> ${mensagem.nomeArquivo}`;
        }

        if (
          this.isPreview(mensagem.nomeArquivo) &&
          !this.isAudio(mensagem.tipoArquivo)
        ) {
          icone = "mdi-file-image-outline";
          return `<i class="v-icon mdi ${icone}" style="font-size: 14px; vertical-align: middle; margin-right: 4px;"></i> ${this.truncate(
            mensagem.nomeArquivo,
            25,
            true,
          )}`;
        }

        return `<i class="v-icon mdi ${icone}" style="font-size: 14px; vertical-align: middle; margin-right: 4px;"></i> ${this.truncate(
          mensagem.nomeArquivo,
          25,
          true,
        )}`;
      }

      // Para mensagens normais de texto
      if (!mensagem.conteudo) return "";

      // Escape HTML para prevenir XSS
      let texto = this.escapeHtml(mensagem.conteudo);

      // Remover quebras de linha
      texto = texto.replace(/\n/g, " ");

      // Aplicar formatação de negrito: **texto** -> <strong>texto</strong>
      texto = texto.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

      // Aplicar formatação de itálico: _texto_ -> <em>texto</em>
      texto = texto.replace(/_(.*?)_/g, "<em>$1</em>");

      // Aplicar formatação de sublinhado: __texto__ -> <u>texto</u>
      texto = texto.replace(/__(.*?)__/g, "<u>$1</u>");

      return texto;
    },

    // Função para escapar HTML e prevenir XSS
    escapeHtml(texto) {
      const div = document.createElement("div");
      div.textContent = texto;
      return div.innerHTML;
    },

    playAlertSound() {
      if (this.userStatus === "NAO_PERTURBE" || !this.notificationPlaysSound) {
        return;
      }

      try {
        const audio = new Audio(require("@/assets/sounds/alerta.wav"));
        audio.volume = this.getNotificationVolume();
        audio.play();
      } catch (error) {
        console.error("Erro ao reproduzir som de alerta:", error);
      }
    },

    getNotificationVolume() {
      const volume = Number(this.chatSettings.volumeNotificacao || 80);
      const normalizedVolume = Math.min(Math.max(volume, 30), 100);

      return normalizedVolume / 100;
    },

    // Carregar participantes do grupo
    async loadParticipants() {
      if (!this.selectedConversation) return;

      try {
        this.loadingParticipants = true;
        const response = await batepapo.listarParticipantes(
          this.selectedConversation.id,
        );
        this.participants = response.data;
        this.loadingParticipants = false;
      } catch (error) {
        console.error("Erro ao carregar participantes:", error);
        this.showSnackbar("Erro ao carregar participantes do grupo", "error");
        this.loadingParticipants = false;
      }
    },

    // Editar nome do grupo
    async editGroupName() {
      if (!this.groupNameEdit || this.groupNameEdit.trim() === "") return;

      this.editingGroupName = true;

      try {
        await batepapo.editarNomeGrupo(
          this.selectedConversation.id,
          this.groupNameEdit.trim(),
        );

        // Atualizar o nome na conversa selecionada
        this.selectedConversation.nomeChat = this.groupNameEdit.trim();

        // Atualizar o nome na lista de conversas
        const conversationIndex = this.conversations.findIndex(
          (c) => c.id === this.selectedConversation.id,
        );
        if (conversationIndex !== -1) {
          this.conversations[conversationIndex].nomeChat =
            this.groupNameEdit.trim();
        }

        this.showSnackbar("Nome do grupo alterado com sucesso!", "success");
        this.groupNameEdit = ""; // Limpar o campo após salvar
      } catch (error) {
        console.error("Erro ao editar nome do grupo:", error);
        this.showSnackbar(
          "Erro ao editar nome do grupo. Tente novamente.",
          "error",
        );
      } finally {
        this.editingGroupName = false;
      }
    },

    // Adicionar membros ao grupo
    async addMembers() {
      if (this.selectedNewMembers.length === 0) return;

      this.addingMembers = true;

      try {
        for (const memberId of this.selectedNewMembers) {
          await batepapo.adicionarParticipante(
            this.selectedConversation.id,
            memberId,
          );
        }

        // Recarregar participantes
        await this.loadParticipants();

        // Limpar seleção
        this.selectedNewMembers = [];

        this.showSnackbar(
          `${this.selectedNewMembers.length} membro(s) adicionado(s) com sucesso!`,
          "success",
        );
      } catch (error) {
        console.error("Erro ao adicionar membros:", error);
        this.showSnackbar(
          "Erro ao adicionar membros ao grupo. Tente novamente.",
          "error",
        );
      } finally {
        this.addingMembers = false;
      }
    },

    // Confirmar remoção de membro
    confirmRemoveMember(participantId) {
      const participant = this.participants.find(
        (p) => p.idParticipante === participantId,
      );
      if (!participant) return;

      this.confirmDialog = {
        show: true,
        title: "Remover participante",
        message: `Tem certeza que deseja remover ${participant.nomeParticipante} do grupo?`,
        confirmText: "Remover",
        color: "error",
        loading: false,
        action: () => this.removeMember(participantId),
      };
    },

    // Remover membro do grupo
    async removeMember(participantId) {
      if (!this.selectedConversation) return;

      try {
        this.confirmDialog.loading = true;

        await batepapo.removerParticipante(
          this.selectedConversation.id,
          participantId,
        );

        // Recarregar a lista de participantes
        await this.loadParticipants();

        this.showSnackbar("Participante removido com sucesso", "success");
        this.confirmDialog.show = false;
        this.confirmDialog.loading = false;
      } catch (error) {
        console.error("Erro ao remover participante:", error);
        this.confirmDialog.show = false;
        this.showSnackbar(error.response.data, "error");
      }
    },

    clearConfirmDelay() {
      if (this.confirmDelayTimer) {
        clearInterval(this.confirmDelayTimer);
        this.confirmDelayTimer = null;
      }
    },

    startConfirmDelay(seconds) {
      this.clearConfirmDelay();
      this.confirmDialog.confirmDelayRemaining = seconds;

      this.confirmDelayTimer = setInterval(() => {
        if (this.confirmDialog.confirmDelayRemaining <= 1) {
          this.confirmDialog.confirmDelayRemaining = 0;
          this.clearConfirmDelay();
          return;
        }

        this.confirmDialog.confirmDelayRemaining -= 1;
      }, 1000);
    },

    closeConfirmDialog() {
      this.clearConfirmDelay();
      this.confirmDialog.show = false;
      this.confirmDialog.loading = false;
      this.confirmDialog.confirmDelayRemaining = 0;
      this.confirmDialog.closesGroup = false;
    },

    onConfirmDialogInput(isOpen) {
      if (!isOpen) {
        this.closeConfirmDialog();
      }
    },

    // Confirmar saída do grupo
    async confirmLeaveGroup() {
      let activeParticipants = [];
      let currentUserParticipant = null;

      try {
        if (this.selectedConversation && this.selectedConversation.tipo === "GRUPO") {
          this.loadingParticipants = true;
          const response = await batepapo.listarParticipantes(
            this.selectedConversation.id,
          );
          this.participants = response.data || [];
          activeParticipants = this.participants.filter((p) => p.ativo !== false);
          currentUserParticipant = activeParticipants.find(
            (p) => p.idParticipante === this.currentUser.id,
          );
        }
      } catch (error) {
        console.error("Erro ao carregar participantes do grupo:", error);
        this.showSnackbar("Erro ao verificar participantes do grupo", "error");
        return;
      } finally {
        this.loadingParticipants = false;
      }

      const isOnlyOwner =
        currentUserParticipant &&
        currentUserParticipant.proprietario &&
        activeParticipants.length === 1;

      this.confirmDialog = {
        show: true,
        title: isOnlyOwner ? "Encerrar grupo" : "Sair do grupo",
        message: isOnlyOwner
          ? "Você é o único participante ativo deste grupo. Ao confirmar, o grupo será excluído."
          : "Tem certeza que deseja sair deste grupo?",
        confirmText: isOnlyOwner ? "Encerrar grupo" : "Sair",
        color: "error",
        loading: false,
        confirmDelayRemaining: 0,
        closesGroup: isOnlyOwner,
        action: () => this.leaveGroup(),
      };

      if (isOnlyOwner) {
        this.startConfirmDelay(6);
      }
    },

    // Sair do grupo
    async leaveGroup() {
      if (!this.selectedConversation) return;

      try {
        this.confirmDialog.loading = true;

        await batepapo.sairDoGrupo(this.selectedConversation.id);

        // Fechar diálogos
        const closesGroup = this.confirmDialog.closesGroup;
        this.closeConfirmDialog();
        this.showManageMembersDialog = false;

        // Recarregar conversas e limpar seleção
        await this.loadConversations();
        this.selectedConversation = null;
        this.messages = [];

        this.showSnackbar(
          closesGroup
            ? "Grupo excluído com sucesso."
            : "Você saiu do grupo com sucesso",
          "success",
        );
        this.confirmDialog.loading = false;
      } catch (error) {
        console.error("Erro ao sair do grupo:", error);
        this.closeConfirmDialog();
        this.showSnackbar(error.response?.data || "Erro ao sair do grupo", "error");
        this.confirmDialog.loading = false;
      }
    },

    // Favoritar ou desfavoritar uma conversa
    async toggleFavorito() {
      try {
        if (!this.selectedConversation) return;

        this.loading = true;

        if (this.selectedConversation.favorito) {
          // Remover dos favoritos
          await batepapo.removerFavoritoConversa(this.selectedConversation.id);
          this.showSnackbar("Conversa removida dos favoritos", "success");
        } else {
          // Adicionar aos favoritos
          await batepapo.favoritarConversa(this.selectedConversation.id);
          this.showSnackbar("Conversa adicionada aos favoritos", "success");
        }

        // Atualizar a lista de conversas
        await this.loadConversations();
      } catch (error) {
        console.error("Erro ao alterar status de favorito:", error);
        this.showSnackbar("Erro ao alterar status de favorito", "error");
      } finally {
        this.loading = false;
      }
    },

    // Confirmar transferência de propriedade
    confirmTransferOwnership(participantId) {
      const participant = this.participants.find(
        (p) => p.idParticipante === participantId,
      );
      if (!participant) return;

      this.confirmDialog = {
        show: true,
        title: "Transferir propriedade",
        message: `Tem certeza que deseja transferir a propriedade do grupo para ${participant.nomeParticipante}?`,
        confirmText: "Transferir",
        color: "warning",
        loading: false,
        action: () => this.transferOwnership(participantId),
      };
    },

    // Transferir propriedade do grupo
    async transferOwnership(participantId) {
      if (!this.selectedConversation) return;

      try {
        this.confirmDialog.loading = true;

        await batepapo.transferirPropriedade(
          this.selectedConversation.id,
          participantId,
        );

        // Recarregar a lista de participantes
        await this.loadParticipants();

        this.showSnackbar("Propriedade transferida com sucesso", "success");
        this.confirmDialog.show = false;
        this.confirmDialog.loading = false;
      } catch (error) {
        console.error("Erro ao transferir propriedade:", error);
        this.showSnackbar("Erro ao transferir propriedade", "error");
        this.confirmDialog.loading = false;
      }
    },

    // Promover participante a administrador
    async promoteToAdmin(participantId) {
      if (!this.selectedConversation) return;

      try {
        this.changingAdminStatus = true;

        await batepapo.promoverAdmin(
          this.selectedConversation.id,
          participantId,
        );

        // Recarregar a lista de participantes
        await this.loadParticipants();

        this.showSnackbar("Participante promovido a administrador", "success");
        this.changingAdminStatus = false;
      } catch (error) {
        console.error("Erro ao promover participante:", error);
        this.showSnackbar("Erro ao promover participante", "error");
        this.changingAdminStatus = false;
      }
    },

    // Rebaixar administrador para participante comum
    async demoteFromAdmin(participantId) {
      if (!this.selectedConversation) return;

      try {
        this.changingAdminStatus = true;

        await batepapo.rebaixarAdmin(
          this.selectedConversation.id,
          participantId,
        );

        // Recarregar a lista de participantes
        await this.loadParticipants();

        this.showSnackbar("Administrador rebaixado com sucesso", "success");
        this.changingAdminStatus = false;
      } catch (error) {
        console.error("Erro ao rebaixar administrador:", error);
        this.showSnackbar("Erro ao rebaixar administrador", "error");
        this.changingAdminStatus = false;
      }
    },

    // Obter ícone e cor do status
    getStatusIcon(status) {
      switch (status) {
        case "ONLINE":
          return { icon: "mdi-check-circle", color: "#4caf50" };
        case "OFFLINE":
          return { icon: "mdi-close-circle", color: "#9e9e9e" };
        case "OCUPADO":
          return { icon: "mdi-circle", color: "#f44336" };
        case "NAO_PERTURBE":
          return { icon: "mdi-minus-circle", color: "#f44336" };
        case "AUSENTE":
          return { icon: "mdi-clock-time-five", color: "#ffc107" };
        default:
          return { icon: "mdi-help-circle", color: "#9e9e9e" };
      }
    },

    // Atualizar status do usuário via WebSocket
    updateUserStatus() {
      if (!this.isConnected || !this.stompClient) {
        console.warn(
          "WebSocket não conectado, não foi possível atualizar status do usuário",
        );
        this.showSnackbar(
          "Não foi possível atualizar seu status. Verifique sua conexão.",
          "error",
        );
        return false;
      }

      // Usar a função do serviço para atualizar o status
      const success = batepapo.updateUserStatusViaWebSocket(
        this.stompClient,
        this.userStatus,
      );

      if (success) {
        return true;
      } else {
        this.showSnackbar("Erro ao atualizar status", "error");
        return false;
      }
    },

    openChatSettingsDialog() {
      this.showChatSettingsDialog = true;
      this.loadChatSettings();
    },

    async loadChatSettings() {
      try {
        this.loadingChatSettings = true;
        const response = await batepapo.obterConfiguracao();

        this.chatSettings = {
          modoNotificacao: response.data.modoNotificacao || "PREVIEW_E_SOM",
          exibirBotaoFlutuante:
            response.data.exibirBotaoFlutuante !== undefined
              ? response.data.exibirBotaoFlutuante
              : true,
          tempoPopupMs: response.data.tempoPopupMs || 6000,
          volumeNotificacao: response.data.volumeNotificacao || 80,
        };
      } catch (error) {
        console.error("Erro ao carregar configurações do bate-papo:", error);
        this.showSnackbar("Erro ao carregar configurações do bate-papo", "error");
      } finally {
        this.loadingChatSettings = false;
      }
    },

    async saveChatSettings() {
      if (this.loadingChatSettings) {
        return;
      }

      try {
        this.savingChatSettings = true;
        const response = await batepapo.salvarConfiguracao(this.chatSettings);

        this.chatSettings = {
          modoNotificacao: response.data.modoNotificacao,
          exibirBotaoFlutuante: response.data.exibirBotaoFlutuante,
          tempoPopupMs: response.data.tempoPopupMs,
          volumeNotificacao: response.data.volumeNotificacao,
        };

        this.showSnackbar("Configurações salvas", "success");
      } catch (error) {
        console.error("Erro ao salvar configurações do bate-papo:", error);
        this.showSnackbar("Erro ao salvar configurações", "error");
        this.loadChatSettings();
      } finally {
        this.savingChatSettings = false;
      }
    },

    formatarContagemCaracteres(valor) {
      return Number(valor || 0).toLocaleString("pt-BR");
    },

    separarMensagemPorLimite(texto) {
      const valor = String(texto ?? "").trim();
      const limite = this.limiteMensagemCaracteres;
      if (!valor) {
        return { enviada: "", restante: "", total: 0, excedeu: false };
      }
      if (valor.length <= limite) {
        return { enviada: valor, restante: "", total: valor.length, excedeu: false };
      }
      return {
        enviada: valor.slice(0, limite),
        restante: valor.slice(limite),
        total: valor.length,
        excedeu: true,
      };
    },

    // Exibir snackbar
    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.timeout = timeout;
      this.snackbar.show = true;
    },
  },

  watch: {
    showNewConversationDialog(val) {
      if (val) {
        this.loadUsers();
      }
    },

    showStartConversationDialog(val) {
      if (val) {
        this.loadUsers();
      }
    },

    showEncaminharDialog(val) {
      if (val && this.users.length === 0) {
        this.loadUsers();
      }
    },

    showManageMembersDialog(val) {
      if (val && this.selectedConversation) {
        this.loadParticipants();
        this.loadUsers();
      }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.chat-wrapper {
  height: calc(100vh - 65px);
  min-height: calc(100vh - 65px);
  max-height: calc(100vh - 65px);
  position: relative;
  overflow: hidden;
}

.chat-main-container {
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  border-bottom: 1px solid #e7e7e7;
}

.chat-main-header {
  background: linear-gradient(135deg, #4caf50 0%, #81c784 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.header-title {
  font-size: 22px;
  font-weight: 700;
  color: white;
  margin: 0;
  letter-spacing: -0.5px;
}

.header-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 2px;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
}

.status-online {
  background-color: #4caf50; /* verde */
}

.status-ausente {
  background-color: #ffc107; /* amarelo */
}

.status-ocupado {
  background-color: #f44336; /* vermelho */
}

.status-nao_perturbe {
  background-color: #f44336; /* vermelho */
}

.status-offline {
  background-color: #9e9e9e; /* cinza */
}

.connection-status.online .status-dot {
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.chat-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.chat-connecting-page {
  flex: 1;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background:
    radial-gradient(circle at top right, rgba(76, 175, 80, 0.14), transparent 32%),
    linear-gradient(135deg, #f8fafc 0%, #eef5f0 100%);
}

.chat-connecting-panel {
  width: min(100%, 420px);
  padding: 32px;
  text-align: center;
}

.chat-connecting-icon {
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: #ecfdf5;
  border: 1px solid #bbf7d0;
  box-shadow: 0 16px 34px rgba(34, 197, 94, 0.14);
}

.chat-connecting-panel h2 {
  margin: 0 0 8px;
  color: #0f172a;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
}

.chat-connecting-panel p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.chat-connecting-progress {
  position: relative;
  width: 210px;
  height: 6px;
  margin: 24px auto 0;
  overflow: hidden;
  border-radius: 999px;
  background: #dbe7df;
}

.chat-connecting-progress span {
  position: absolute;
  top: 0;
  left: -45%;
  width: 45%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #4caf50, #81c784);
  animation: connecting-progress 1.25s ease-in-out infinite;
}

@keyframes connecting-progress {
  0% {
    left: -45%;
  }
  100% {
    left: 100%;
  }
}

.chat-disconnected-page {
  flex: 1;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background:
    radial-gradient(circle at top left, rgba(76, 175, 80, 0.12), transparent 34%),
    linear-gradient(135deg, #f8fafc 0%, #eef5f0 100%);
}

.chat-disconnected-panel {
  width: min(100%, 520px);
  padding: 34px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.12);
  text-align: center;
}

.chat-disconnected-icon {
  width: 88px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.chat-disconnected-label {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  margin-bottom: 14px;
  border-radius: 999px;
  background: #fff7ed;
  color: #c2410c;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.chat-disconnected-panel h2 {
  margin: 0 0 10px;
  color: #0f172a;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
}

.chat-disconnected-panel p {
  margin: 0;
  color: #475569;
  font-size: 15px;
  line-height: 1.6;
}

.chat-retry-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 44px;
  margin: 24px 0 18px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f8fafc;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}

.chat-retry-button {
  color: #ffffff !important;
  box-shadow: 0 10px 20px rgba(76, 175, 80, 0.22) !important;
}

.conversations-sidebar {
  width: 380px;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
}
.sidebar-header {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.sidebar-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}

.sidebar-action-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn {
  color: #64748b !important;
  background-color: #f1f5f9 !important;
  transition: all 0.2s ease !important;
}

.btn:hover {
  color: #4caf50 !important;
  background: #e8f5e9 !important;
}

.primary-action {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
  color: white !important;
}

.primary-action:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.status-select {
  max-width: 160px;
  border-radius: 20px !important;
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  font-size: 13px !important;
}

.status-select >>> .v-input__slot {
  padding: 0 12px !important;
  background: white !important;
  box-shadow: none !important;
}

.status-chip {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-text {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
}

.status-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
  font-size: 13px;
  color: #334155;
}

.sidebar-search {
  padding: 0 16px 16px;
}

.search-input {
  border-radius: 12px !important;
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
}

.conversations-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 12px;
}
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.conversations-list::-webkit-scrollbar {
  width: 6px;
}

.conversations-list::-webkit-scrollbar-track {
  background: transparent;
}

.conversations-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.conversation-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 6px;
  background: #ffffff;
  border: 1px solid transparent;
}

.conversation-item:hover {
  background: #f1f5f9;
  transform: translateX(2px);
}

.conversation-item.active {
  background: white;
  border-color: #e5e7eb;
}

.conversation-avatar {
  position: relative;
  flex-shrink: 0;
}

.avatar-circle {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  color: white;
  text-transform: uppercase;
}

.avatar-indigo {
  background: linear-gradient(135deg, #4caf50 0%, #81c784 100%);
}
.avatar-purple {
  background: linear-gradient(135deg, #2196f3 0%, #64b5f6 100%);
}
.avatar-pink {
  background: linear-gradient(135deg, #4caf50 0%, #a5d6a7 100%);
}
.avatar-blue {
  background: linear-gradient(135deg, #2196f3 0%, #90caf9 100%);
}
.avatar-teal {
  background: linear-gradient(135deg, #00897b 0%, #4db6ac 100%);
}
.avatar-orange {
  background: linear-gradient(135deg, #ff9800 0%, #ffb74d 100%);
}

.avatar-system {
  background: linear-gradient(135deg, #2196f3 0%, #64b5f6 100%);
  border: 1px solid rgba(255, 255, 255, 0.45);
  box-shadow: 0 4px 10px rgba(33, 150, 243, 0.18);
}

.group-indicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: #4caf50;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.self-chat-indicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: #00897b;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-indicator {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 2px solid #ffffff;
}

.conversation-status-dot {
  width: 8px;
  height: 8px;
}

.conversation-info {
  flex: 1;
  min-width: 0;
}

.conversation-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.conversation-name {
  font-weight: 600;
  font-size: 15px;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-cargo {
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-time {
  font-size: 12px;
  color: #94a3b8;
  flex-shrink: 0;
}

.conversation-preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.preview-content {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.preview-text-container {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  max-width: 100%;
}

.sender-name {
  font-weight: 600;
  color: #4caf50;
  margin-right: 4px;
  font-size: 13px;
  white-space: nowrap;
  flex-shrink: 0;
}

.preview-text {
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}

.empty-conversations {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
  gap: 12px;
}

.conversation-section {
  margin-bottom: 8px;
}
.conversation-expansion {
  margin-top: 0 !important;
  background-color: #f8fafc !important;
}
::v-deep .conversation-expansion .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.section-header {
  padding: 8px 16px 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.chat-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  min-width: 0;
}

.messages-area {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.btn-novas-mensagens {
  position: absolute;
  right: 20px;
  bottom: 16px;
  z-index: 3;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.18);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-novas-mensagens:hover {
  background: #f8fafc;
}

.btn-novas-mensagens-badge {
  position: absolute;
  top: -6px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 999px;
  background: #4caf50;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
}

.chat-header {
  padding: 16px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chat-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.chat-avatar {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  color: white;
  text-transform: uppercase;
}

.chat-info {
  display: flex;
  flex-direction: column;
}

.chat-name {
  font-weight: 700;
  font-size: 16px;
  color: #1e293b;
}

.chat-status {
  font-size: 13px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.online-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
}

.chat-header-actions {
  display: flex;
  gap: 4px;
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.messages-container::-webkit-scrollbar {
  width: 6px;
}

.messages-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}


.messages-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message-row {
  display: flex;
}

.message-row.sent {
  justify-content: flex-end;
}

.message-row.received {
  justify-content: flex-start;
}

.message-bubble {
  max-width: 65%;
  min-width: 200px;
  padding: 14px 18px;
  border-radius: 20px;
  position: relative;
}

.message-row.sent .message-bubble {
  background: linear-gradient(135deg, #4caf50 0%, #81c784 100%);
  color: white;
  border-bottom-right-radius: 6px;
}

.message-row.received .message-bubble {
  background: #ffffff;
  color: #1e293b;
  border-bottom-left-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.message-sender {
  font-size: 12px;
  font-weight: 600;
  color: #4caf50;
  margin-bottom: 6px;
}

.message-bubble.has-actions {
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.message-actions-btn {
  opacity: 0.85;
}

.message-actions-btn:hover,
.message-actions-btn:focus-visible {
  opacity: 1;
}

.message-bubble.message-highlight {
  box-shadow: 0 0 0 3px rgba(250, 204, 21, 0.9), 0 6px 18px rgba(15, 23, 42, 0.18);
  transform: scale(1.01);
}

.message-reply-preview:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
  outline-offset: 1px;
}

.message-reply-author {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
}

.message-reply-text {
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.9;
}

.reply-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.reply-bar-content {
  flex: 1;
  min-width: 0;
  padding: 6px 10px;
  border-left: 4px solid #4caf50;
  border-radius: 8px;
  background: #f1f5f9;
  color: #1e293b;
}

.message-text {
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-wrap;
}

.message-text p {
  margin: 0;
}

.message-text a {
  color: #4caf50;
  text-decoration: underline;
}
.message-file-content {
  max-width: 360px;
  margin-bottom: 10px;
}

.file-preview {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 6px;
}

.preview-pdf {
  width: 100%;
  height: 220px;
  border: none;
  border-radius: 8px;
}

.audio-preview {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 6px;
}

.audio-player {
  width: 100%;
  height: 60px;
  border-radius: 20px;
  outline: none;
}

/* Estilização para o player de áudio */
.sent .audio-preview {
  background-color: rgba(255, 255, 255, 0.2);
}

.received .audio-preview {
  background-color: rgba(0, 0, 0, 0.03);
}

/* Gravador de áudio */
.audio-recorder-container {
  padding: 10px;
}

.audio-visualizer {
  height: 80px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.audio-visualizer.is-recording {
  background-color: rgba(244, 67, 54, 0.1);
}

.time-counter {
  font-size: 24px;
  font-weight: 500;
  color: #4caf50;
  margin-bottom: 10px;
}

.audio-visualizer.is-recording .time-counter {
  color: #f44336;
}

.wave-container {
  display: flex;
  align-items: center;
  height: 30px;
}

.wave {
  width: 3px;
  height: 15px;
  margin: 0 3px;
  background-color: #4caf50;
  border-radius: 2px;
}

.audio-visualizer.is-recording .wave {
  background-color: #f44336;
  animation: wave 1s infinite ease-in-out;
}

.audio-visualizer.is-recording .wave:nth-child(1) {
  animation-delay: 0s;
}
.audio-visualizer.is-recording .wave:nth-child(2) {
  animation-delay: 0.2s;
}
.audio-visualizer.is-recording .wave:nth-child(3) {
  animation-delay: 0.4s;
}
.audio-visualizer.is-recording .wave:nth-child(4) {
  animation-delay: 0.6s;
}
.audio-visualizer.is-recording .wave:nth-child(5) {
  animation-delay: 0.8s;
}

@keyframes wave {
  0%,
  100% {
    height: 5px;
  }
  50% {
    height: 25px;
  }
}

.audio-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.audio-preview-player {
  width: 100%;
  max-width: 300px;
  height: 40px;
  border-radius: 20px;
  outline: none;
}

/* Card do arquivo */
.file-card {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 10px 12px;
}

/* Nome e tamanho */
.file-name {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  max-width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-size {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

/* Ações */
.file-actions {
  display: flex;
  margin-left: 10px;
}

.file-actions .v-btn {
  opacity: 0.7;
}

.file-actions .v-btn:hover {
  opacity: 1;
}

.sent .file-info {
  background-color: rgba(255, 255, 255, 0.2);
}

.received .file-info {
  background-color: rgba(0, 0, 0, 0.05);
}

.message-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}

.message-time {
  font-size: 11px;
  opacity: 0.7;
}

.message-status {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.message-row.sent .message-time {
  color: rgba(255, 255, 255, 0.8);
}

.messages-container.empty {
  display: flex;
  align-items: center;
  justify-content: center;
}

.messages-container.messages-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

.empty-messages {
  text-align: center;
}

.empty-icon-wrapper {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  border-radius: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.empty-messages h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.empty-messages p {
  font-size: 14px;
  color: #64748b;
}

/* ===== Área de Input ===== */
.message-input-area {
  padding: 16px 24px 24px;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.message-input-area.system-readonly {
  align-items: center;
  color: #64748b;
  display: flex;
  font-size: 13px;
  gap: 8px;
  justify-content: center;
  min-height: 64px;
  padding: 14px 24px;
}

.input-toolbar {
  margin-bottom: 12px;
}

.format-buttons {
  display: flex;
  align-items: center;
  gap: 2px;
}

.toolbar-divider {
  width: 1px;
  height: 24px;
  background: #e2e8f0;
  margin: 0 8px;
}

.input-container {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.message-textarea {
  flex: 1;
  max-height: 192px;
  overflow: hidden;
  border-radius: 16px !important;
  background: #f8fafc !important;
  border: 2px solid #e2e8f0 !important;
  transition: all 0.2s ease;
}

.message-textarea:focus-within {
  border-color: #4caf50 !important;
  background: #ffffff !important;
}

.message-textarea >>> .v-input__control,
.message-textarea >>> .v-input__slot,
.message-textarea >>> .v-text-field__slot {
  max-height: 188px;
  overflow: hidden;
}

.message-textarea >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  padding: 12px 16px !important;
  min-height: 48px !important;
}

.message-textarea >>> textarea {
  display: block;
  font-size: 14px;
  line-height: 1.5;
  max-height: 164px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.send-button {
  flex-shrink: 0;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4) !important;
}

.send-button:disabled {
  background: #cbd5e1 !important;
  box-shadow: none !important;
}

/* ===== Estado sem Conversa ===== */
.no-conversation-selected {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
}

.welcome-illustration {
  position: relative;
  margin-bottom: 32px;
}

.illustration-circles {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.circle {
  position: absolute;
  border-radius: 50%;
  border: 2px solid rgba(99, 102, 241, 0.2);
  animation: ripple 3s infinite;
}

.circle-1 {
  width: 120px;
  height: 120px;
  top: -60px;
  left: -60px;
  animation-delay: 0s;
}
.circle-2 {
  width: 180px;
  height: 180px;
  top: -90px;
  left: -90px;
  animation-delay: 0.5s;
}
.circle-3 {
  width: 240px;
  height: 240px;
  top: -120px;
  left: -120px;
  animation-delay: 1s;
}

@keyframes ripple {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}

.no-conversation-selected h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.no-conversation-selected p {
  font-size: 15px;
  color: #64748b;
}

/* ===== Diálogos ===== */
.views-dialog,
.new-conversation-dialog,
.chat-settings-dialog {
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(135deg, #4caf50 0%, #81c784 100%);
  color: white !important;
  padding: 16px 24px !important;
}

.dialog-content {
  padding: 24px !important;
}

.dialog-actions {
  border-top: 1px solid #e2e8f0;
}

.chat-settings-header {
  display: flex;
  align-items: center;
  line-height: 1.3;
}

.chat-settings-header-subtitle {
  margin-top: 3px;
  font-size: 13px;
  font-weight: 400;
  opacity: 0.9;
}

.chat-settings-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  background-color: #f8fafc;
}

.chat-settings-section {
  padding: 18px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  transition: opacity 0.2s ease;
}

.chat-settings-section--disabled {
  opacity: 0.72;
}

.chat-settings-section-heading {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.chat-settings-section-icon {
  display: flex;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  background-color: #e8f5e9;
  border-radius: 10px;
}

.chat-settings-section-title {
  color: #1e293b;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
}

.chat-settings-section-description {
  margin-top: 3px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
}

.chat-settings-disabled-hint {
  margin-top: 10px;
  color: #64748b;
  font-size: 12px;
}

.chat-settings-switch-section {
  padding-top: 16px;
  padding-bottom: 16px;
}

.chat-settings-switch-copy {
  flex: 1;
}

.chat-settings-switch {
  flex: 0 0 auto;
  margin: 0 0 0 12px;
  padding: 0;
}

.chat-settings-actions {
  min-height: 56px;
  padding: 8px 16px;
}

.chat-settings-saving {
  display: flex;
  align-items: center;
  color: #64748b;
  font-size: 12px;
}

@media (max-width: 600px) {
  .chat-settings-content {
    padding: 16px !important;
  }

  .chat-settings-section {
    padding: 15px;
  }
}

.confirm-dialog-card {
  overflow: hidden;
  border-radius: 12px;
}

.confirm-dialog-message {
  color: #334155;
  line-height: 1.5;
  white-space: pre-line;
  font-size: 15px;
}

.confirm-dialog-body {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 16px;
}

.confirm-delay-hint {
  color: #b45309;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background-color: #fff7ed;
  border-radius: 6px;
  padding: 10px 12px;
}

.viewer-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.viewer-item:last-child {
  border-bottom: none;
}

.viewer-avatar {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  color: white;
}

.viewer-info {
  display: flex;
  flex-direction: column;
}

.viewer-name {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
}

.viewer-time {
  font-size: 12px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 4px;
}

.no-viewers {
  text-align: center;
  padding: 40px 0;
  color: #94a3b8;
}

.no-viewers p {
  margin-top: 12px;
}

/* ===== Emoji Picker ===== */
.emoji-picker-wrapper {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

/* ===== Gerenciamento de Membros ===== */
.manage-members-dialog {
  overflow: hidden;
}

.member-item {
  border-bottom: 1px solid #f1f5f9;
  padding: 12px 0;
}

.member-item:last-child {
  border-bottom: none;
}

.member-item .v-list-item__avatar {
  margin-right: 16px;
}

.member-item .v-list-item__content {
  padding: 4px 0;
}

.member-item .v-list-item__title {
  font-weight: 600;
  font-size: 15px;
  display: flex;
  align-items: center;
}

.member-item .v-icon.amber--text {
  color: #ffc107 !important;
}

.member-item .v-chip--outlined {
  border-color: #4caf50;
  color: #4caf50;
  font-size: 10px;
  height: 20px !important;
  font-weight: 600;
}

/* ===== Mensagens do Sistema ===== */
.message-system-wrapper {
  display: flex;
  justify-content: center;
  margin: 8px 0;
  width: 100%;
}

.message-system {
  background-color: #fffde7;
  border-radius: 8px;
  padding: 6px 12px;
  max-width: 80%;
  text-align: center;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.message-system-content {
  font-size: 13px;
  color: #555;
}

/* ===== Mensagens de Data (Separador) ===== */
.message-date-wrapper {
  display: flex;
  justify-content: center;
  margin: 16px 0 8px;
  width: 100%;
}

.message-date {
  background-color: #e2e2e2;
  border-radius: 8px;
  padding: 5px 12px;
  max-width: 60%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.message-date-content {
  font-size: 12px;
  color: #505050;
  font-weight: 500;
  text-align: center;
}

/* ===== Responsivo ===== */
@media (max-width: 960px) {
  .chat-wrapper {
    padding: 0px;
  }

  .chat-main-container {
    border-radius: 16px;
    height: calc(100vh - 24px);
  }

  .conversations-sidebar {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 100%;
  }

  .chat-content {
    position: relative;
  }

  .chat-area {
    position: relative;
    z-index: 0;
  }

  .message-bubble {
    max-width: 85%;
    min-width: 150px;
  }
  .messages-container {
  padding: 16px;
}
}

.cursor-pointer {
  cursor: pointer;
}
</style>
